{
  "settings": {
    "calendar": {
      "calendar_settings": "Configurações do calendário",
      "settings": "Configurações",
      "select_calendar_type": "Selecionar tipo de calendário",
      "add_new_calendar_group": "Adicionar novo grupo de calendário",
      "add_new_equipment": "Adicionar novo equipamento",
      "new_calendar": "Novo calendário",
      "calendar_group_description": "Use o Grupo de calendário para ordenar e agrupar com eficiência vários calendários.",
      "group": "Grupo",
      "manage_your_calendars_and_groups": "Gerencie seus calendários e grupo",
      "groups": "Grupo",
      "create_group": "Criar grupo",
      "create_calendar": "Criar calendário",
      "calendar_name": "Nome do calendário",
      "group_duration": "Duração do grupo",
      "calendar_type": "Digitar",
      "action": "Ação",
      "round_robin": "Rodízio",
      "event": "Evento",
      "group_name": "Nome do grupo",
      "room_name": "Nome da sala",
      "group_description": "Descrição do grupo",
      "calendar_url": "URL do calendário",
      "calendars": "Calendários",
      "date_updated": "Data da atualização",
      "status": "Status",
      "action_dropdown": "Menu suspenso de ações",
      "calendar_list": "Serviços associados a",
      "edit": "Editar",
      "duplicate": "Duplicar",
      "copy_embed_code": "Copiar código de incorporação",
      "copy_permanent_link": "Copiar link permanente",
      "copy_new_slug_link": "Copiar link de programação",
      "copy_scheduling_link": "Copiar link de programação (legado descontinuado)",
      "deactivate_calendar": "Desativar calendário",
      "move_to_group": "Mover para o grupo",
      "delete_calendar": "Excluir calendário",
      "delete_group": "Excluir",
      "delete_this_group": "Excluir este grupo",
      "activate_calendar": "Ativar calendário",
      "duration": "Duração",
      "all": "todos",
      "draft": "Rascunhar",
      "inactive": "Inativo",
      "active": "Dinâmico",
      "actions": "Atividades",
      "rearrange_calendars": "Reorganizar calendários",
      "deactivate_all_calendars_in_group": "Suspender todos os calendários in Grupo",
      "activate_all_calendars_in_group": "gatilho todos os calendários in Grupo",
      "no_groups_found": "Seu Pesquisar não correspondeu a nenhum calendário do Grupo.",
      "no_groups_in_location": "Grupo Ordenar seus calendários Curtir Pasta. Adicione calendários a um grupo e compartilhe um Link individuais de programação, permitindo que a Agendador selecione de vários calendários.",
      "no_calendars_found": "Comece Via calendário Via calendário criado novo.",
      "no_calendars_found_search": "Seu Pesquisar não correspondeu a nenhum calendário.",
      "delete_calendar_message": "Você está prestes a excluir o calendário. Ao clicar em excluir, todos os compromissos também serão excluídos.",
      "delete_calendar_message_title": "Excluir este calendário?",
      "duplicate_calendar_message": "Você está prestes a duplicar o calendário. Isso criará um novo calendário com as mesmas configurações do calendário selecionado.",
      "duplicate_calendar_message_title": "Duplicar este calendário?",
      "no_calendars_found_title": "Nenhum calendário encontrado",
      "no_groups_in_location_title": "Nenhum grupo encontrado",
      "delete_group_confirmation_title": "Excluir esse grupo?",
      "delete_group_confirmation": "Tem certeza de que deseja excluir o selecionado grupo?",
      "delete_group_confirmation_checkbox_title": "Excluir calendários e compromissos de Membros",
      "delete_group_confirmation_checkbox_description": "Selecionar esta opção também excluirá os calendários in grupo, junto com todos o compromisso in calendários.",
      "group_status_message_title": "{status} grupo e todos os calendários associados?",
      "calendar_status_message_title": "{status} este calendário?",
      "calendar_status_message": "Você está prestes a {status} o calendário.",
      "group_status_active_message": "Tem certeza de que deseja habilitar este grupo? Todos os calendários dentro do grupo também serão habilitados e estarão disponíveis para agendamento.",
      "group_status_inactive_message": "Tem certeza de que deseja desabilitar este grupo? Todos os calendários do grupo também serão desativados e ficarão disponíveis para reservas.",
      "coming_soon": "Em breve",
      "select": "Selecionar",
      "15mins": "15 min",
      "cancel": "Cancelar",
      "save": "Salvar",
      "create": "Criar",
      "select_calendar_group": "Selecionar grupo de calendário",
      "move_calendar_confirmation": "O link antigo deixará de funcionar assim que você prosseguir com essa alteração. Confirme marcando a caixa de seleção.",
      "previously_called_unassigned": " (anteriormente chamado como não atribuído)",
      "scheduling_type": "Escolher tipo de calendário",
      "scheduling_type_description": "selecionar um tipo de calendário para a configuração do seu calendário e personalizar como o compromisso é programado.",
      "service_menu_name": "Nome do menu de serviços",
      "template": "Modelo",
      "select_template": "Selecionar modelo",
      "group_url": "URL do Grupo",
      "template_description": "Agora você tem a opção de selecionar os modelos Clássico ou Neo para a visualização de grupo.",
      "rooms": "Sala",
      "rooms_name": "Nome",
      "rooms_description": "Descrição",
      "rooms_modal_description": "Adicionar ou editar sala.",
      "rooms_capacity": "Capacidade total",
      "no_rooms_in_location_title": "Nenhuma sala encontrada",
      "no_rooms_in_location": "Nenhuma sala encontrada in localização",
      "no_equipments_in_location": "Nenhum equipamentos encontrado in localização",
      "equipments": "Equipamentos",
      "equipment_name": "Nome",
      "equipment_name_search": "Nome do equipamento",
      "equipment_description": "Descrição",
      "equipment_modal_description": "Adicionar ou editar um equipamento.",
      "add_equipment": "Adicionar/editar equipamento",
      "add_room": "Adicionar/editar sala",
      "equipment_quantity": "Quantidade total",
      "equipment_outOfService": "Quantidade fora de serviço",
      "no_equipments_in_location_title": "Nenhum equipamentos encontrado",
      "delete_this_equipment": "Excluir este Equipamentos",
      "delete_this_rooms": "Excluir esta sala",
      "delete_equipment_confirmation": "Tem certeza de que deseja excluir este Equipamentos? Este será o Apagado de todos os Calendários externos também.",
      "delete_rooms_confirmation": "Tem certeza de que deseja excluir esta Sala? Este será o Apagado de todos os Calendários externos também.",
      "add_new_calendar_equipments": "Adicionar novo Equipamentos",
      "no_equipments_found": "Seu Pesquisar não correspondeu a nenhum Equipamentos.",
      "no_rooms_found": "Seu Pesquisar não correspondeu a nenhuma Sala.",
      "add_new_calendar_rooms": "Adicionar nova Sala",
      "rooms_disable": "Desativar sala",
      "equipments_disable": "Desativar equipamento",
      "equipments_activate": "Ative o equipamento",
      "rooms_activate": "Ativar sala",
      "create_equipments": "Criar equipamento",
      "create_rooms": "Criar sala",
      "select_calendar_rooms_title": "Selecionar calendário",
      "select_calendar_rooms_description": "Você pode selecionar vários calendários para associar a salas.",
      "select_calendar_equipments_title": "Selecionar calendário",
      "select_calendar_equipments_description": "Você pode selecionar um calendário para associar ao equipamento.",
      "disable_equipment_title": "{status} Equipamentos",
      "disable_room_title": "{status} Sala",
      "equipments_status_message": "Tem certeza de que deseja {status} este equipamento?",
      "rooms_status_message": "O senhor tem certeza de que deseja {status} este quarto?",
      "calendar_resource_disclaimer": "Isso pode afetar os calendários de serviços da Disponibilidade Ativado Membros.",
      "equipment_disclaimer": "Observação: habilitar os Equipamentos mais tarde o reconectará automaticamente aos calendários com os seus Membros",
      "room_disclaimer": "Observação: habilitar a Sala mais tarde a reconectará automaticamente aos calendários com os quais são Membros",
      "equipment_tab_name": "Equipamentos",
      "rooms_tab_name": "Sala",
      "manage_your_rooms": "Gerenciar a sala para sua empresa aqui",
      "manage_your_equipments": "Gerenciar Equipamentos para sua Empresa aqui",
      "select_service_calendar_description_equipments": "Você pode selecionar vários calendários de serviços para associar ao equipamento.",
      "select_service_calendar_description_rooms": "Você pode selecionar múltiplos calendários de serviços para associar a salas.",
      "service_menus": "Menu de serviços",
      "manage_your_calendars_groups_and_service_menus": "Gerencie seus calendários, grupo e menu de serviços",
      "new_service_menu": "Criar menu de serviços",
      "deactivate_service_menu": "Desativar menu de serviços",
      "delete_service_menu": "Excluir este menu de serviços",
      "delete_service_menu_confirmation": "Tem certeza de que deseja excluir este menu de serviço?",
      "service_menu_status_message_title": "{status} este menu de serviços?",
      "service_menu_status_message": "O senhor está prestes a acessar o menu de serviços {status}.",
      "no_service_menus_in_location_title": "Crie o seu menu de serviços personalizado",
      "add_new_service_menu": "Adicionar novo menu de serviços",
      "no_service_menus_in_location": "Iniciar a Via Criado um novo menu de serviço e adicionar o Grupo a ele",
      "no_service_menu_found": "Nenhum menu de serviços encontrado",
      "no_service_menu_found_desc": "Seu Pesquisar não correspondeu a nenhum menu de serviço.",
      "apply": "Aplicar",
      "troubleshoot_calendar": "Solucionar problemas de calendário",
      "round_robin_booking": "Rodízio",
      "round_robin_description": "Distribuição de compromissos entre o Grupo Membros in um Ordenar móvel.",
      "round_robin_example": "Por exemplo: ligações de vendas, sessões de integração.",
      "unassigned_booking": "Calendário de eventos",
      "unassigned_description": "Para ocorrências físicos Programar sem proporção de Host .",
      "unassigned_example": "Por exemplo: Conferências, webinars do Público, mostras.",
      "event_booking_alert_title": "Importante",
      "event_booking_alert_message": "Este tipo de calendário tem diferenças importantes.",
      "event_booking_learn_more": "Saiba mais",
      "event_booking_tooltip_title": "Coisas importantes:",
      "event_booking_tooltip_content": "• Os calendários de eventos não têm usuários, portanto, as reuniões não podem ser atribuídas a um usuário.\n• Como nenhum usuário foi atribuído, as ferramentas de link de reunião dinâmico não são compatíveis (Zoom, Google Meet, Microsoft Teams). Para usar reuniões online, copie um link de conferência estático de qualquer ferramenta e cole-o no local da reunião.\n• Como nenhum usuário está atribuído, as reuniões não são sincronizadas com o calendário do usuário em Configurações do Calendário → Conexões. Calendários conflitantes adicionados ali não são considerados.\n• As reuniões são sincronizadas apenas com o calendário selecionado em Sincronização externa para este calendário.\n• Os eventos são obtidos e enviados apenas para o calendário externo selecionado.\n• Apenas um calendário Google pode ser conectado usando a sincronização externa.",
      "class_booking": "Reserva de aulas",
      "class_booking_description": "Um Host atende com vários Membros.",
      "class_booking_example": "Por exemplo: Webinars, Grupo Cursos, Cursos on-line.",
      "collective_booking": "Reserva coletiva",
      "collective_booking_description": "Vários Hosts se conhecem com um Membros.",
      "collective_booking_example": "Por exemplo: conversas de painel, avaliações de Conselhos.",
      "service_booking": "Reserva de serviço",
      "service_booking_description": "Programação perfeita para empresas baseada em serviços.",
      "service_booking_example": "Por exemplo: Compromisso de spam, Serviços de revisão, consultas.",
      "personal_booking": "Reserva pessoal",
      "personal_booking_description": "Programar uma reunião-ativada com um Grupo específico de Membros.",
      "personal_booking_example": "Por exemplo: Reuniões de clientes, consultas privada.",
      "personal": "Pessoal",
      "explore_more_types": "explore mais categorias",
      "no_calendars_added": "Ainda não há calendários, configure um!",
      "no_calendars_added_description": "Crie seu primeiro calendário para iniciar o Programar sem esforço.",
      "no_groups_added": "Ainda não há grupos, comece a organizá-los!",
      "no_calendars_yet": "Ainda não há calendários",
      "no_groups_yet": "Ainda não há grupos",
      "no_calendars_access": "Nenhum calendário foi criado ainda. Depois que um calendário for criado, ele aparecerá aqui. Você não tem Acesso para criar um calendário — entre em contato com seu administrador se precisa.",
      "no_groups_access": "Nenhum grupo ainda está configurado. Depois que um grupo for criado, ele aparecerá aqui. Você não tem Acesso para Criar um Grupo — entre em contato com seu administrador se necessário.",
      "no_groups_added_description": "Use o Grupo para manter seus calendários configurados. Adicionar calendários a um grupo e compartilhar um Link de grupo Indivíduo de programação para reserva descompromisso.",
      "group_success_message": "O grupo é criado com sucesso. Você pode agora incluir calendários a este grupo.",
      "choose_calendars": "Selecione os calendários",
      "do_it_later": "Farei isso mais tarde",
      "add_calendars_to_group": "Adicionar calendários ao grupo",
      "select_calendars_to_add": "Selecione todos os calendários Você deseja Incluir ao Grupo {name}",
      "add_calendars": "Adicionar calendário(s)",
      "continue": "Continuar",
      "conflicting_calendars": "Calendários em conflito",
      "conflicting_calendars_description": "Os calendários posteriores já fazem parte de Outro Grupo. Você quer mova-os para seu novo grupo, <b>{name}</b>?",
      "group_associated_with": "Grupo Atual",
      "move_calendar_consent": "I Habilitar Movendo estes calendários para o novo grupo.",
      "calendars_moved_successfully": "todos os calendários selecionados foram movidos com sucesso para {name}.",
      "new_group": "Novo grupo",
      "back": "Voltar",
      "share_otl": "Compartilhe sua Disponibilidade todos os dados com um Link exclusivo que Vence Depois de uma reserva, certifique-se de gerenciar o acesso.",
      "copied_to_clipboard": "Copiado para a área de transferência",
      "generate_link": "Gerar novo link",
      "generate_link_error": "Não foi possível gerar um link único. Tente novamente",
      "share_schedule_link": " O Link de programação é definido Via o Slug. Modifique o Slug, e o Link de programação se dade automaticamente à alteração.",
      "share_permanent_link": "Ideal para Funis, Redirecionamentos de Website , Ou Anúncios, o Link permanente permanece permanente, não afetada Via Slug Dinâmico.",
      "copy": "Copiar",
      "share_embed_code": "Localização este código in seu HTML , onde Você deseja que seu Widget {embedType} aparece.",
      "scheduling_link": "Link de programação",
      "permanent_link": "Link permanente",
      "one_time_link": "Link único",
      "embed_code": "Incorporar código",
      "loading": "Carregando...",
      "share_group": "Compartilhar grupo",
      "edit_group": "Editar grupo",
      "more_options": "Mais opções",
      "share_calendar": "Compartilhar calendário",
      "edit_calendar": "Editar calendário",
      "troubleshoot_calendar_link": "Solucionar problemas de calendário",
      "calendar_config_success": "Você configurado com sucesso seu calendário pessoal/de grupo",
      "close": " Fechar",
      "added_calendars": "Calendário(s) adicionado(s)",
      "select_calendars": "Selecionar calendário(s)",
      "settings_confirmation": "Para a Prosseguir, confirme essas Dinâmico.",
      "consent_checkbox_title": "Eu compreendo e aceito essas alterações.",
      "confirm": "Confirmar",
      "create_group_access_disabled": "Você não tem autorização para Criar um grupo. Contato seu administrador para Acesso.",
      "create_calendar_access_disabled": "Você não tem autorização para criar um calendário. Contato seu administrador para Acesso.",
      "preview_booking_widget": "Pré-visualização do widget de reserva",
      "share_service_menu": "Compartilhar menu de serviços",
      "back_message": "Voltar para a lista de calendários",
      "service_calendars": "Calendários de serviço",
      "owned_by": "Via de proprietário",
      "owned_by_anyone": "Qualquer pessoa",
      "owned_by_me": "Eu",
      "all_groups": "Todos os grupos",
      "all_calendars": "Todos os calendários",
      "not_grouped": "Não agrupado",
      "delete_group_desc": "Tem certeza de que deseja excluir este grupo? Isso também apagará todos os calendários Membros com este grupo.",
      "calendar_listing_title": "Listagem de calendário",
      "calendar_group_name": "Nome do calendário/grupo",
      "success": "Sucesso",
      "my_calendar": "meu-calendário",
      "service_calendar_description": "Programação simplificada para empresas de serviços."
    },
    "preferences": {
      "preferences": "Configurações",
      "my_preferences": "Minha preferência",
      "account_preferences": "Preferências da conta",
      "user_preferences": "Preferências do usuário",
      "set_preferences": "Coleção suas configurações para sua conta.",
      "scheduling_options": "Opções de programação",
      "meeting_location": "Conferência encontrada",
      "zoom": "Zoom",
      "save_preferences": "Salvar preferências",
      "in_app_preferences": "Nas preferências do app",
      "set_start_day": "Coleção Configurações",
      "view_options": "Opções de visualização",
      "services": "Serviços",
      "feature_toggle_aria": "Alternância de recurso",
      "week_starts_on": "A semana começa em",
      "sunday": "domingo",
      "widget_preferences": "Configurações Widget",
      "set_widget_language": "Coleção Configurações Curtir Idioma para Widget",
      "language_and_region": "Idioma e Estado",
      "language": "Idioma",
      "english": "Ingls",
      "time_format": "Formato de hora",
      "time_format_value": "1:30 PM",
      "monday": "segunda-feira",
      "custom_meeting_location": "Localização personalizada da reunião",
      "view_appointments_in_1": "Visualizar compromissos em",
      "timezone_uses_details_1": "Usaremos este fuso horário para exibir os horários dos agendamentos no app e nos seus e-mails relacionados a agendamentos — apenas para você. Isso não afetará a sua disponibilidade nem os agendamentos de outras pessoas com você.",
      "business_timezones_1": "Fuso horário comercial",
      "business_timezones_tooltip_1": "Mensagem: Escolher esta opção garante que sua Preferência de visualização esteja alinhada com o Fuso horário da Empresa selecionado. Se o fuso horário da Empresa mudar, seu fuso horário de visualização será automaticamente ajustado para corresponder.",
      "recommended_timezones": "Fusos horários recomendados",
      "all_timezones": "Todos os fusos horários"
    },
    "availability": {
      "availability": "Disponibilidade",
      "my_availability": "Minha disponibilidade",
      "my_availability_and_booking_rules": "Programação de disponibilidade",
      "my_availability_and_booking_rules_description": "Defina quando as reuniões podem ser marcadas com base na disponibilidade da equipe.",
      "account_availability": "Disponibilidade da conta",
      "timezone": "Fuso horário",
      "working_hours": "Horário comercial",
      "set_recurring_hours": "Coleção sua hora de trabalho recorrente para a Conferência",
      "select_one": "Selecionar um",
      "sunday": "domingo",
      "monday": "segunda-feira",
      "tuesday": "Terça-feira",
      "wednesday": "Quarta-feira",
      "thursday": "Quinta-feira",
      "friday": "sexta-feira",
      "saturday": "sábado",
      "widget_preferences": "Configurações Widget",
      "set_widget_language": "Coleção Configurações Curtir Idioma para Widget",
      "language_and_region": "Idioma e Estado",
      "language": "Idioma",
      "english": "Ingls",
      "copy_to_all": "Copiar para todos",
      "save_availability": "Salvar disponibilidade",
      "add_time": "Adicionar horário",
      "to": "Para",
      "select_time": "Selecionar horário",
      "add_user": "Adicionar usuário",
      "accessRestricted": {
        "header": "Acesso restrito",
        "message": "Você não faz parte desta conta. Para obter acesso, adicione-se a esta conta em Configurações da agência > Teams > Editar membro da equipe e atribua a conta em \"Funções e permissões\".",
        "contact_admin": "Esta página é pública apenas para administradores. Entre em contato com seu administrador para obter assistência.",
        "button_text": "Vá para Configurações da agência."
      },
      "schedule": {
        "edit_schedule": "Editar programação",
        "schedule_name": "Nome da programação",
        "schedule_name_required": "O nome da programação é obrigatório",
        "timezone": "Fuso horário",
        "timezone_placeholder": "Selecione um",
        "start_time": "Hora de início",
        "end_time": "Hora de término",
        "add_availability_hour": "Adicionar horário de disponibilidade",
        "remove_availability_hour": "Remover hora de disponibilidade",
        "unavailable": "Indisponível",
        "schedule_created": "Programação criada com sucesso",
        "schedule_updated": "Programação atualizada com sucesso",
        "calendars_selected": "{count} calendário",
        "calendars_selected_multiple": "{count} calendários",
        "select_users_placeholder": "Pesquisar usuários",
        "edit_default_schedule": "Editar esta programação",
        "customize_event_type_schedule": "Personalizar a programação apenas para este calendário",
        "multi_user_description": "Atualizar disponibilidade para <b>{count} usuários selecionados</b> - {calendar}",
        "bulk_edit_warning_banner": "Edição em massa ativada. As alterações substituirão as programações existentes para todos os usuários selecionados.",
        "bulk_edit_slot_applies_to_all": "O intervalo selecionado será aplicado a todos os usuários selecionados.",
        "bulk_edit_slot_applies_to_selected": "O intervalo selecionado será aplicado a {count} usuário(s) selecionado(s).",
        "bulk_edit_applies_to_all": "As alterações serão aplicadas a todos os {count} usuários selecionados.",
        "bulk_edit_weekly_hours": "Horários semanais de edição em massa",
        "bulk_edit_weekly_hours_title": "Horários semanais de edição em massa",
        "bulk_edit_weekly_hours_desc": "Isso substituirá as horas semanais de todos os usuários listados abaixo.",
        "edit_now": "Editar agora",
        "bulk_edit": "Edição em massa",
        "choose_days_weekly_hours": "Escolha o(s) dia(s) para definir as horas semanais",
        "assign_to": "Atribuir a:",
        "configure_weekly_hours": "Configurar horários semanais",
        "selected_users": "Usuários selecionados:",
        "bulk_edit_select_users": "Selecionar usuários para aplicar",
        "bulk_edit_select_users_placeholder": "Selecionar membros da equipe...",
        "bulk_edit_select_at_least_one": "Selecione pelo menos um usuário.",
        "bulk_edit_editing_for": "Edição para:",
        "bulk_edit_applies_to": "Aplica-se a:",
        "bulk_edit_user_count": "{count} usuário",
        "bulk_edit_users_count": "{count} usuários",
        "show_less": "Mostrar menos",
        "more": "mais",
        "confirm_delete": "Confirmar exclusão",
        "confirm": "Confirmar",
        "delete_user_date_confirm": "Tem certeza de que deseja excluir as horas específicas para <b>{userName}</b> em <b>{date}</b>?",
        "delete_date_confirm": "Tem certeza de que deseja excluir as horas específicas da data para todos os usuários em <b>{date}</b>?",
        "selected_calendar": "calendário selecionado",
        "edit_schedule_alert": "As atualizações feitas aqui serão aplicadas a",
        "schedule": "Programar",
        "no_availability": "Sem disponibilidade",
        "date_specific_hours_show_more": "mais",
        "date_specific_hours_show_less": "menos",
        "date_specific_hours_recurring_meetings_enabled": "Não é possível adicionar horários específicos da data porque esta programação está vinculada a um calendário com reuniões recorrentes habilitadas. Para continuar, desabilite as reuniões recorrentes.",
        "recurring_incompatible_with_date_hours": "Reuniões recorrentes não podem ser habilitadas porque a programação do usuário tem horários específicos da data, o que é incompatível.",
        "incompatible_schedule_with_recurring": "A programação {user} contém horários específicos para datas, o que é incompatível com reuniões recorrentes.",
        "incompatible_schedule_with_recurring_calendar": "A programação contém horários específicos para datas, o que é incompatível com reuniões recorrentes.",
        "recurring_meetings_enabled_multi_user": "Reuniões recorrentes não são compatíveis com calendários com vários membros da equipe ou quando um membro da equipe tem horas específicas de data adicionadas à sua programação.",
        "weekdays": "Dias úteis, {timeRange}",
        "weekdays_hours_vary": "Dias úteis, horário variável",
        "weekend": "Fim de semana, {timeRange}",
        "weekend_hours_vary": "Fim de semana, horário variável",
        "days_hours_vary": "{days}, horário variável",
        "date_specific_hours_tab_name": "Horários específicos para cada data",
        "date_specific_hours": "{count} horários específicos da data",
        "date_specific_hours_1": "1 horário específico da data",
        "weekly_hours": "Horas semanais",
        "custom_schedule": "Programação personalizada",
        "select_schedule": "Selecione uma programação",
        "no_schedules_found": "Nenhuma programação encontrada",
        "untitled": "Sem título",
        "error_updating_schedules": "Erro ao atualizar as programações",
        "daily": "Diário",
        "weekly": "Semanalmente",
        "monthly": "Mensalmente",
        "custom": "Personalizado",
        "this_is_required": "Isto é obrigatório",
        "search": "Pesquisar",
        "edit_hours": "Editar horas",
        "schedule_name_duplicate": "Já existe uma programação com este nome",
        "delete_schedule_title": "Excluir a programação '{scheduleName}'?",
        "delete_schedule_description": "Essa ação não pode ser desfeita. Tem certeza de que deseja continuar?",
        "delete_schedule_negative_text": "Cancelar",
        "delete_schedule_positive_text": "Sim, excluir.",
        "active_on": "Ativo(a) em",
        "weekly_working_hours": "Horário de funcionamento semanal",
        "weekly_working_hours_subtext": "Selecione os dias e horários em que você trabalha",
        "copy_availability_hour": "Copiar horário de disponibilidade",
        "mins": "Minutos",
        "hours": "Horas",
        "save_weekly_hours": "Salvar horas semanais",
        "save_date_specific_hours": "Salvar horas específicas da data",
        "update_weekly_hours_for_users": "Atualizar horas semanais para {count} usuários",
        "set_date_specific_hours_for_users": "Definir horários específicos por data para {count} usuários",
        "set_date_specific_hours_for_user": "Definir horários específicos da data"
      }
    },
    "connections": {
      "connections": "Conexões",
      "connect": "conectar",
      "conferencing": "Conferência",
      "my_connections": "Minhas conexões",
      "account_connections": "Conexões de conta",
      "connection_preferences": "Preferências de conexão",
      "manage_calendars_conferencing_channels": "Gerenciar calendários e canais de Conferência",
      "main_integration_calendar": "Calendário principal de integração",
      "event_integration_calendar": "ocorrências criadas ativadas a um calendário do sistema do qual Você faz parte também serão criadas ativadas neste calendário integrado",
      "2way_sync": "Sincronização de duas via: Criar Sistema ocorrências De ocorrências reservadas Ativado o PRINCIPAL calendário integrado",
      "calendars": "Calendários",
      "google": "Google",
      "outlook": "Outlook",
      "check_for_conflicts": "Verificar conflitos",
      "choose_accounts_to_connect": "selecione qual Conta Você deseja conectar",
      "payments": "Pagamentos",
      "stripe": "Stripe",
      "ads": "Anúncios",
      "local_service_ads": "Anúncios de serviço local",
      "fire_workflow": "Dispare acionadores de fluxo de trabalho para eventos agendados via sincronização bidirecional",
      "connect_google_outlook": "Conecte sua conta Google/Outlook/iCloud para poderá selecionar o calendário PRINCIPAL.",
      "execute_automation": "Executar automação",
      "save": "Salvar",
      "lsa": "Anúncios de serviço local",
      "no_write_access": "Você não escrever Acesso a este calendário",
      "connection_remove_confirmation": "Você está sobre para remover esta integração",
      "active": "Dinâmico",
      "icloud": {
        "title": "Integração iCloud",
        "description": "A autenticação de dois fatores e uma password específicas do aplicativo são obrigatórias para conectar sua Conta.",
        "email": "Endereço de e-mail iCloud",
        "password": "iCloud",
        "connect": "Conectar",
        "cancel": "Cancelar"
      }
    }
  },
  "appointment_modal": {
    "select_a_contact": "Selecione um contato",
    "start_time": "Hora de início",
    "unassigned": "Não atribuído",
    "end_time": "Hora de término",
    "search_by_name_email_phone_or_company": "Pesquisar Via nome, E-mail, Telefone Ou Empresa",
    "add_new": "Adicionar novo(a)",
    "pick_from_available_contacts": "Ou selecionar de Amigos disponíveis",
    "book_appointment": "Agendar compromisso",
    "add_blocked_off_time": "Adicionar horário bloqueado",
    "recommended_timezones": "Fusos horários recomendados",
    "all_timezones": "Todos os fusos horários",
    "calendar": "Calendário",
    "repeat": "Repetição",
    "date_and_time": "Data e hora",
    "close": "Fechar",
    "team_member": "Membro do grupo",
    "recurring_booking": "Reserva recorrente",
    "one_slot_booking": "Reserva de um intervalo",
    "event_type": "Tipo de evento",
    "occurrences_booked": "ocorrências serão reservadas",
    "repeats": "Repete",
    "booking_details": "Detalhes da reserva",
    "showing_slots_in_this_timezone": "Exibindo intervalos in fuso horário:",
    "update_contact_tz": "Atualize também o fuso horário do contato para",
    "date": "Data",
    "slot": "intervalo",
    "calendar_default": "Calendário padrão",
    "custom": "Personalizado(a)",
    "meeting_notes": "(por exemplo) Notas de conferência para nosso próximo compromisso",
    "out_of_office": "(por exemplo) De story para a Semana!",
    "standard": "Padrão",
    "appointment_title": "Título do compromisso",
    "event_title": "Título do evento",
    "appt_with_bob": "(por exemplo) Compromisso com João",
    "vacation": "(por exemplo) férias",
    "show_notes": "Exibir observações",
    "hide_notes": "Ocultar observações",
    "additional_preferences": "Preferências adicionais",
    "meeting_location": "Localização da reunião",
    "appointment_status": "Status do compromisso",
    "appt_description": "Descrição do compromisso",
    "recurring_details": "Detalhes recorrentes",
    "event_description": "Descrição do evento",
    "in_contact_timezone": "in fuso horário do contato",
    "vacation_message": "Vai sair de férias Ativado? Vai tirar alguns dados desabilitado? Bloquear dados desabilitados, ative seu calendário para evitar que a reserva de clientes Compromisso atual ainda permanecerá ativada em seu calendário).",
    "contact": "Contato",
    "delete": "Excluir",
    "cancel": "Cancelar",
    "back": "Voltar",
    "pick_available_contacts": "Ou selecionar de Amigos disponíveis",
    "no_contacts_found": "Nenhum parceiro encontrado",
    "found": "encontrado",
    "select_one": "Selecione um(a)",
    "tz_tooltip": "Isso só importa Se Você está Via Valores personalizados; como Compromisso Compromisso Compromisso etc.. in suas Enviadas Comunicação com seus Clientes Ou Clientes. E o que ele simplesmente faz é converter os detalhes acima mencionados em seus dados locais.",
    "meeting_location_tooltip": "A Conferência Localização será a coleção, conforme configurado in calendário.",
    "appt_meeting_location_tooltip": "O usuário pode a coleção a Conferência Localização específicas do compromisso.",
    "gmeet_tooltip": "Certifique-se de que o membro da equipe em questão tenha a Google Agenda configurado como seu calendário principal.",
    "zoom_tooltip": "Por favor, certifique-se de que o respectivo membro da equipe tenha o Zoom integrado.",
    "enter_meeting_location": "Insira o local da reunião",
    "save_appointment": "Salvar compromisso",
    "save_event": "Salvar evento",
    "search_contacts": "Pesquisar Via nome, E-mail, Telefone Ou Empresa",
    "recurring_slots": "{recurringSlotsLength}/{count}",
    "custom_timezone": "Fuso horário personalizado",
    "system_timezone": "Fuso horário do sistema",
    "contact_timezone": "Fuso horário do contato",
    "account_timezone": "Fuso horário da conta",
    "an_error_occurred": "Ocorreu um erro"
  },
  "popup": {
    "calendar": "Calendário",
    "appointment_owner": "Proprietário do compromisso",
    "source": "Fonte",
    "booked_by": "Agendado por",
    "view_activity_log": "Visualizar registro de atividades",
    "status": "Status",
    "cancel_appointment": "Cancelar compromisso",
    "cancel_all": "Cancele tudo",
    "google_event": "Evento do Google",
    "outlook_event": "Evento do Outlook",
    "blocked_slot": "Intervalo bloqueado",
    "appointment": "Compromisso",
    "confirmed": "Confirmado",
    "unconfirmed": "Não confirmado",
    "cancelled": "Cancelado",
    "showed": "Comparecido",
    "no_show": "Não compareceu",
    "invalid": "Inválido",
    "more": "Mais",
    "less": "Menor",
    "edit": "Editar",
    "reschedule_all": "Reagendar todos",
    "guests": "Convidado(s)",
    "guest_count": "Contagem de Convidado(s)"
  },
  "create_calendar": {
    "calendar_name": "Nome do calendário",
    "calendar_logo": "Logotipo do calendário",
    "select_team_member": "selecionar Grupo Membros",
    "select_single_team_member": "Selecionar membro da equipe",
    "eg_outbound_reach": "(por exemplo) Alcance Enviadas",
    "description": "Descrição",
    "amount": "Valor",
    "description_placeholder": "Escreva a descrição",
    "meeting_duration": "Duração da reunião",
    "meeting_location": "Local da reunião",
    "seats_per_class": "Assentos por Aula",
    "group": "Grupo",
    "custom_url": "URL Personalizado",
    "meeting_invite_title": "Conferência convites Título",
    "event_color": "Cor do Evento",
    "availability_type": "Disponibilidade digital",
    "new_calendar": "Novo calendário",
    "add_description": "Adicionar descrição",
    "remove_description": "Descrição do extrato",
    "booking_availability": "Disponibilidade da reserva",
    "slug_tooltip": "Personalize a URL do widget de reservas.",
    "meeting_location_tooltip": "Os links de reunião são exibidos nos eventos do calendário como \"Local da reunião\" e permitem que você adicione itens como links do Zoom para o evento.",
    "advanced_settings": "Configurações avançadas",
    "show_more_schedule": "Mostrar mais",
    "show_more_helper_text": "Para personalizar ainda mais seu horário de funcionamento, acesse as configurações avançadas.",
    "reschedule_preference": "Preferência de reagendamento",
    "reschedule_preference_subtext": "Se um {contactLabel} reagendar um compromisso:",
    "reassign_through_round_robin": "Reatribuir a Via Rodízio",
    "keep_same_assinged_user": "Manter o mesmo Compromisso Proprietário",
    "new_appointment_preference": "Nova preferência de compromisso",
    "new_appointment_preference_text": "Sempre agendar com o usuário atribuído do {contactLabel}.",
    "new_appointment_preference_subtext": "Agende novos compromissos com o usuário atribuído do {contactLabel}, em vez de usar o agendamento em rodízio.",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "service_calendar_name": "Nome do serviço",
    "service_logo": "Logotipo do serviço",
    "service_select_team_member": "Selecionar membro da equipe",
    "service_duration": "Duração do serviço",
    "appointment_invite_title": "Título de convite do Compromisso",
    "payment_placeholder": "Insira uma descrição que será exibida para o usuário, informações sobre o pagamento",
    "deposit_amount": "Valor do depósito",
    "collect_deposit_amount": "Aceitar pagamento incompleto",
    "percentage": "Porcentagem",
    "total_amount": "Valor total",
    "enter_meeting_location": "Digite o local da reunião",
    "accept_payments": "Aceitar pagamentos",
    "aria": {
      "should_accept_payment": "Deve aceitar pagamento"
    },
    "calendar_name_tooltip": "Nome do calendário a ser exibido no widget de reservas.",
    "booking_availability_tooltip": "Defina os dias e horários durante os quais as reservas podem ser feitas. Estes são seus horários comerciais semanais padrão exibidos aos usuários ao selecionar um intervalo.",
    "select_team_member_tooltip": "Selecione os membros da equipe que participariam dessa reunião.",
    "seats_per_class_tooltip": "Defina o número máximo de participantes permitidos para reservar esta aula. Assim que todos os assentos forem preenchidos, o intervalo de tempo não estará mais disponível para reserva.",
    "meeting_color": "Conferência Cor",
    "meeting_duration_tooltip": "Isso define a duração da sua reunião, determinando quanto tempo ela irá durar."
  },
  "calendar_advanced": {
    "general": {
      "quick_tip": "Dica rápida",
      "timezone_change_tip": "Os fusos horários podem ser alterados a qualquer momento em \"Preferências de fuso horário\".",
      "save": "Salvar alterações",
      "close": "Fechar",
      "meeting_details": "Detalhes básicos",
      "availability": "Disponibilidade",
      "forms_and_payment": "Formulários e pagamento",
      "notifications_and_additional_options": "Notificações e opções adicionais",
      "connections": "Conexões",
      "customizations": "Personalizações",
      "create": "Criar",
      "edit": "Editar",
      "equipments": "Salas e equipamentos",
      "service_details": "Detalhes do serviço",
      "booking_rules": "Regras de reserva",
      "advanced_settings": "Configurações avançadas",
      "form_and_confirmation": "Formulário e Confirmação",
      "payments": "Pagamentos",
      "notifications_and_policies": "Notificações e Políticas",
      "widget_appearance": "Aparência do widget",
      "saving_changes": "Apenas um minuto — Salvando o Dinâmico mais recente...",
      "calendar_id": "ID do calendário",
      "saveCalendarSuccess": "Calendário salvo com sucesso",
      "external_sync": "Sincronização externa",
      "booking_channels": "Canais de reserva",
      "meeting_location": "Localização da reunião",
      "staff_location": "Equipe e localização"
    },
    "meeting_details": {
      "meeting_location": "Conferência encontrada",
      "meeting_location_label": "Localização da reunião",
      "enter_meeting_location": "Digite a conferência localização",
      "click_to_upload": "clicar para Carregar",
      "square": "Quadrado",
      "circle": "Círculo",
      "remove_logo": "Extrair logotipotipo",
      "meeting_invite_title_tooltip": "Este é o título da reunião do calendário que aparece na sua exibição em Lista de compromissos, na Visualização de calendário e em Calendários de terceiros.",
      "event_color_tooltip": "Escolha uma cor para este evento de agendamento. As cores são sincronizadas com os eventos na Google Agenda.",
      "enter_a_name": "Insira um nome.",
      "enter_an_event_title": "Por favor, insira o título do evento.",
      "high_priority": "Alta prioridade",
      "medium_priority": "Prioridade média",
      "low_priority": "Prioridade baixa",
      "priority": "Prioridade",
      "custom": "Personalizado(a)",
      "zoom_not_added": "O usuário ainda não conectou a conta do Zoom.",
      "opt_avail": "Otimizar para disponibilidade",
      "opt_equal": "Otimizar para entrega igual",
      "team_members": "selecionar Grupo Membros",
      "team_members_location": "Selecione a equipe e atribua o local da reunião",
      "team_member": "Selecionar membro da equipe",
      "team_member_location": "Selecione a equipe e atribua o local da reunião",
      "meeting_location_required": "O local da reunião é obrigatório.",
      "meeting_details": "Detalhes básicos",
      "meeting_details_description": "Informações básicas utilizadas para identificar este calendário.",
      "or_drag_and_drop": "Ou Arrastar e soltar",
      "service_details": "Detalhes do serviço",
      "team_member_disabled_recurring_tooltip": "Reuniões recorrentes Habilitar apenas um Grupo Membros. Para incluir vários Membros do Grupo, Desabilitar Reuniões recorrentes.",
      "team_member_disabled_class_booking_tooltip": "Somente um membro da equipe pode ser adicionado a um calendário de reserva de aulas.",
      "advanced_settings": "Configurações avançadas",
      "enable_contact_assigned_to_setting": "Para habilitar esta configuração, o formulário deve ser o primeiro in Widget Ordenar. Reagendar o Widget Ordenar De a aba Formulários e pagamento.",
      "reschedule_preference_setting_tooltip": "Selecionar a quem o compromisso deve ser atribuído quando um {contactLabel} for reagendado a partir do widget de agendamento.",
      "appointment_preference_tooltip": "Selecione se novos compromissos devem ser sempre agendados com o usuário atribuído do {contactLabel}. Se um {contactLabel} tiver um usuário atribuído, esse usuário terá preferência; caso contrário, será uma atribuição em rodízio. Dica: desabilite \"Habilitar seleção de equipe\" para evitar que os agendadores alterem o membro da equipe no widget de reserva.",
      "add_location": "Adicionar localização",
      "multiple_locations_neo": "Ofereça várias opções de localização para o cliente escolher. Múltiplas localizações são suportadas apenas pelo Neo Widget.",
      "make_owner": "Criar Proprietário",
      "only_one_team_member": "Somente um Grupo Membros é permitido Quando vários endereços são adicionados.",
      "ask_the_booker_error_message": "A localização do responsável pela reserva já existe.",
      "enter_location": "Digite o valor da localização",
      "enter_display_label": "Insira o rótulo de exibição",
      "add_display_label": "Adicionar rótulo de exibição",
      "multiple_location_support_message": "Ofereça várias opções de localização para o cliente escolher. Múltiplas localizações são suportadas apenas pelo Neo Widget.",
      "only_one_team_member_personal_calendar": "Apenas um membro da equipe tem permissão para fazer uma reserva pessoal. ",
      "ms_teams_not_added": "O usuário ainda não conectou a conta do Microsoft Teams.",
      "enable_new_appt_preference": "Habilitar nova preferência de compromisso",
      "enable_new_appt_preference_desc": "Ao habilitar &quot;<b>Sempre agendar com o usuário atribuído do {contactLabel}</b>&quot; o <b>Formulário</b> será sempre definido como a primeira etapa na ordem do widget.",
      "location_exists_toast": "Conferência de localização já adicionada",
      "not_supported_with_multiple_team_members": "Não é compatível com vários membros da equipe",
      "not_supported_personal_calendar": "Não é compatível com o calendário pessoal",
      "not_supported_class_booking": "Não é compatível com calendários de reserva de aulas",
      "not_supported_collective_booking": "Não é compatível com o calendário coletivo",
      "not_supported_service_booking": "Não é compatível com o calendário de serviço",
      "not_supported_round_robin": "Não é compatível com o calendário de rodízio",
      "not_supported_event": "Não é compatível com o calendário de eventos",
      "calendar_logo_tooltip": "Escolha um logotipo para ser exibido no widget de reservas.",
      "calendar_name_tooltip": "Nome do calendário a ser exibido no widget de reservas.",
      "description_tooltip": "Descreva o propósito do calendário para ser exibido no widget de reserva.",
      "group_tooltip": "Você pode atribuir este calendário a um grupo (se já estiver criado). Usuários que acessam o link do grupo podem visualizar e agendar em todos os calendários desse grupo.",
      "custom_url_tooltip": "Personalize a URL do widget de reservas.",
      "meeting_color_tooltip": "Escolha uma cor para este evento de agendamento. As cores são sincronizadas com os eventos na Google Agenda.",
      "add_display_label_tooltip": "Oculte a localização real e exiba um rótulo personalizado até que a reunião seja marcada (aplica-se quando várias localizações são adicionadas).",
      "meeting_location_tooltip": "Selecione uma localização ou escolha Personalizado para adicionar qualquer endereço ou link de reunião.",
      "team_members_location_tooltip": "Selecione o membro da equipe que conduzirá esta reunião e defina a localização da reunião.",
      "meeting_distribution": "Distribuição de reuniões",
      "meeting_distribution_tooltip": "Escolha como as reuniões são atribuídas aos funcionários.",
      "opt_avail_tooltip": "Atribua reuniões ao membro da equipe que estiver disponível no horário selecionado, independentemente de reservas anteriores. Maximiza a utilização de intervalos abertos e as taxas de sucesso de reservas.",
      "opt_equal_tooltip": "Distribua as reuniões de forma equilibrada entre todos os funcionários, acompanhando as reservas anteriores. Prioriza a equidade em vez da disponibilidade.",
      "priority_tooltip": "Defina o nível de preferência para atribuir reuniões quando houver múltiplos funcionários disponíveis. Os funcionários de maior prioridade serão considerados primeiro para as reservas, seguidos pelos funcionários de prioridade média e baixa.",
      "contact_routing_preference": "Preferência de roteamento de contatos",
      "contact_routing_preference_tooltip": "Defina como os {contactsLabel} novos e os que retornam são atribuídos à equipe — seja por rodízio ou por seu proprietário original.",
      "team_members_location_owner_tooltip": "O usuário principal é o responsável pela reunião e fornece a localização definitiva da reunião.",
      "owner": "Proprietário",
      "upload_from_system": "Carregar do sistema",
      "choose_from_media_storage": "Selecionar no armazenamento de mídias",
      "only_one_team_member_allowed": "Apenas um membro da equipe é permitido.",
      "at_least_two_team_members_required": "São necessários pelo menos 2 membros da equipe.",
      "at_least_one_team_member_required": "Pelo menos um membro da equipe é necessário.",
      "widget_shape": "Formato do widget:",
      "widget_bookings_path": "/widget/reservas/",
      "contact_name_placeholder": "&#123;&#123; contact.name &#125;&#125;",
      "profile_photo_alt": "foto do perfil",
      "meeting_location_placeholder": "Localização da reunião",
      "team_member_meeting_location": "Equipe e localização da reunião",
      "meeting_location_desc": "Atribua a equipe a este calendário e defina onde as reuniões ocorrerão.",
      "event_calendar_meeting_location_desc": "Escolha onde a reunião será realizada."
    },
    "meeting_location": {
      "ask_the_booker": "Pergunte ao responsável pela reserva (o responsável pela reserva insere o local)",
      "ask_the_booker_desc": "O usuário é solicitado a inserir uma localização de reunião de sua escolha ao fazer a reserva",
      "zoom": "Zoom",
      "google_meet": "Google Meet",
      "microsoft_teams": "Microsoft Teams",
      "phone": "Telefone",
      "full_address": "Endereço completo",
      "custom": "Personalizado(a)",
      "meeting_location": "Localização da reunião"
    },
    "availability": {
      "my_availability": "Minha disponibilidade",
      "calendar_availability": "Disponibilidade do calendário",
      "calendar_availability_desc": "Defina quando as reuniões podem ser marcadas neste calendário.",
      "set_availability": "Coleção sua disponibilidade para o calendário aqui.",
      "standard": "Padrão",
      "custom": "Personalizado(a)",
      "to": "Para",
      "copy_to_all": "Copiar para todos",
      "add_time": "Adicionar dados",
      "recurring_meeting": "Conferência Recorrente",
      "recurring_info": "Apenas um usuário por calendário para reservas recorrentes.",
      "repeat": "Repetição",
      "times_to_repeat": "vezes para Repetição",
      "slots_unavailable": "Se os intervalos não estiverem disponíveis?",
      "overlap_status": "Status do Compromisso para intervalos sobrepostas ",
      "meeting_interval": "Intervalo da reunião",
      "meeting_duration": "Duração da reunião",
      "minimum_scheduling": "Mínimo Programar AVSO",
      "date_range": "Escopos de dados",
      "maximum_bookings_per_day": "Máximo de reservações por dia",
      "maximum_bookings_per_slot": "Máximo de agendamentos por intervalo",
      "maximum_bookings_per_slot_per_user": "Máximo de agendamentos por intervalo (por usuário)",
      "seats_per_class": "Assentos por Aula",
      "pre_buffer_time": "Tempo de buffer prévio",
      "post_buffer_time": "Tempo de buffer posterior",
      "pre_buffer_tooltip": "Pré-buffer é um tempo adicional que pode ser adicionado antes de um compromisso, permitindo mais tempo para se preparar.",
      "post_buffer_tooltip": "O pós-buffer é um tempo adicional que pode ser adicionado após um compromisso, permitindo um tempo extra para conclusão.",
      "buffer_time": "Dados de BUFFER",
      "daily": "Diário",
      "weekly": "Semanalmente",
      "monthly": "Mensalmente",
      "skip_booking": "Ignorar reserva de intervalos não disponíveis",
      "continue_booking": "Continuar reserva",
      "book_next_available": "Agendar Próximo intervalo disponível",
      "confirmed": "Confirmado",
      "unconfirmed": "Não confirmado",
      "enter_valid_hours": "Insira uma hora aberta válida",
      "enter_valid_avail": "Insira uma disponibilidade personalizada válida",
      "availability_type_tooltip": "selecionar o padrão Disponibilidade para agendamentos mensalmente oferecido semanalmente. Selecionar personalizado para agendamentos disponíveis apenas em datas específicas ativadas.",
      "meeting_interval_tooltip": "Controla a frequência com que os intervalos de reserva são exibidos.\nPara uma reunião de 30 minutos: \n• Escolha 1 hora para exibir os intervalos no início de cada hora. \n• Escolha 30 minutos para mostrar os intervalos a cada 30 minutos.",
      "date_range_tooltip": "ocorrências podem ser Programadas ao longo dos Próximos dias.",
      "maximum_bookings_per_day_tooltip": "Número máximo de reuniões permitidas por dia neste calendário.",
      "maximum_bookings_per_slot_tooltip": "Limite quantas reuniões um usuário pode receber no mesmo intervalo. Se o limite for atingido, a reserva é atribuída ao próximo usuário na fila de rodízio ou o intervalo se torna indisponível.",
      "add_days": "Adicionar dias",
      "month_on_day": "Mensalmente ativado dia",
      "month_on_last_day": "Mensalmente Ativado último",
      "day": "Dia",
      "week": "Semana",
      "month": "Mês",
      "mins": "Minutos",
      "hours": "Horas",
      "days": "Dias",
      "weeks": "Semanas",
      "months": "Meses",
      "meeting_interval_error": "O intervalo da reunião deve ser entre 5 minutos e 12 horas.",
      "meeting_duration_error": "A duração da reunião deve estar entre 1 min e 12 horas.",
      "buffer_time_error": "O tempo de buffer deve ser inferior a 12 horas.",
      "appointment_interval": "Compromisso Segundos",
      "appointment_duration": "Duração do Compromisso",
      "maximum_appointments_per_day": "Máximo compromisso por dia",
      "subTitle": "Selecione a data para definir horários específicos.",
      "heading_1": "Horas disponíveis por semana",
      "scheduling_availability_heading": "Disponibilidade de agendamento",
      "scheduling_availability_tooltip": "Use uma programação de disponibilidade existente ou crie uma personalizada para este calendário.",
      "tooltip_1": "Defina sua programação de disponibilidade semanalmente. Estas são as suas horas padrão que serão aplicadas consistentemente em uma base semanal.",
      "heading_2": "Quando Você está disponível?",
      "unavailable_label": "Não disponível",
      "tooltip_2": "Modifique sua programação para datas específicas. Substitui sua mensalmente semanalmente hora Via marcando a Disponibilidade ou a não disponibilidade para datas selecionadas.",
      "date_specific_level": "Adicionar datas específicas de hora",
      "specific_hours_button": "Horários específicos para cada data",
      "specific_hours_description": "Defina a disponibilidade personalizada para datas específicas que diferem da sua programação semanal.",
      "overlap_error": "Intervalos de dados não podem SOBREPOSIÇÃO",
      "apply": "Aplicar",
      "copy_times_to": "Copiar vezes para",
      "no_date_specific_heading": "Nenhum horário específico de data adicionado.",
      "no_date_specific_description": "Você pode adicionar/remover data e hora específicas à sua disponibilidade.",
      "recurring_disabled_conditions_tooltip": "Reuniões recorrentes estão desabilitadas. Para gatilhos, certifique-se de que o calendário tenha apenas um Grupo Membros e não tenha hora específicas ou pagamento incompleto adicionado.",
      "date_specific_hours_disabled_conditions_tooltip": "Para incluir uma hora com data específicas, certifique-se de que as Reuniões recorrentes estejam desabilitadas.",
      "recurring_disable_event_calendar_conditions": "Reuniões recorrentes estão desabilitadas. Para ativá-los, certifique-se de que nenhum pagamento específico ou incompleto seja adicionado.",
      "service_duration": "Duração do serviço",
      "service_interval": "Segundos de serviço",
      "service_interval_tooltip": "O intervalo da reunião define com que frequência os intervalos de reserva aparecem no calendário. Por exemplo, para um evento de 30 minutos, um intervalo de 1 hora significa que os intervalos aparecem a cada hora. Um intervalo de 30 minutos significa que os intervalos aparecem a cada 30 minutos.",
      "service_duration_tooltip": "Essa fixa o comprimento do seu compromisso, determinando quanto tempo ele será o último.",
      "minimum_scheduling_tooltip": "Isso define o tempo mínimo necessário para marcar um compromisso por meio do widget de calendário. Por exemplo, se definido para 4 horas, os compromissos não podem ser agendados dentro de 4 horas do horário de início; as reservas devem ser feitas com pelo menos 4 horas de antecedência.",
      "look_busy_title": "Pareça ocupado",
      "look_busy_helper_text": "Ocultar a porcentagem de seus intervalos de compromisso disponíveis Ativado o agendamento do Widget para aparecer mais ocupado e in grande demanda.",
      "look_busy_percentage_description": "Ocultar o número de intervalos disponíveis em x%.",
      "maximum_bookings_per_slot_tooltip_personal": "Número máximo de reuniões permitidas em um único intervalo de tempo.",
      "enable_recurring_title": "Habilitar reunião recorrente",
      "enable_recurring_desc": "Habilitar <b>Reuniões recorrentes</b> desabilitará automaticamente as seguintes configurações, pois elas não podem coexistir:",
      "date_specific_hours": "Todos os <b>horários específicos da data</b> serão removidos.",
      "multiple_team_members": "<b>Vários membros do grupo</b> serão removidos — somente um membro poderá permanecer neste calendário.",
      "partial_payments": "<b>Pagamentos incompletos</b> serão Desabilitados, e o valor de Concluído será cobrado.",
      "select_team_member_to_keep": "selecionar um Grupo Membros para manter in calendário:",
      "select_team_member": "Selecionar membro da equipe",
      "partial_payments_disabled": "Como os pagamentos parciais serão desabilitados, como você gostaria de cobrar o valor total dos compromissos recorrentes?",
      "enable_date_specific_hours": "Habilitar horários específicos para cada data",
      "enable_date_specific_hours_desc": "Ativar <b>Horários específicos de data</b> desabilitará automaticamente a seguinte configuração, pois não podem coexistir:",
      "recurring_meetings_disabled": "<b>Reuniões recorrentes serão desabilitadas</b>, {contactsLabel} só poderá agendar compromissos individuais com base nas datas disponíveis que você configurar.",
      "payment_preference": "Preferência de pagamento:",
      "team_members_in_this_calendar": "Membros da equipe neste calendário",
      "other_team_members": "Outros membros da equipe (não adicionados a este calendário)",
      "select_team_member_tooltip": "Selecione os membros da equipe que participariam dessa reunião.",
      "meeting_duration_tooltip": "Isso define a duração da sua reunião, determinando quanto tempo ela irá durar.",
      "date_specific_hours_tooltip": "Ajuste sua programação para datas específicas. Substitua seu horário semanal regular marcando disponibilidade ou indisponibilidade para datas selecionadas.",
      "recurring_meeting_tooltip": "Permita que as reuniões se repitam várias vezes ao longo de um período de tempo.",
      "repeat_frequency_tooltip": "Selecione a frequência deste evento recorrente.",
      "time_to_repeat_tooltip": "Defina o número total de recorrências.",
      "slots_unavailable_tooltip": "Escolha o que deve acontecer se um ou mais intervalos de tempo em uma reserva recorrente já estiverem ocupados.",
      "skip_booking_tooltip": "Somente os intervalos disponíveis serão reservados. As datas indisponíveis na série de compromissos recorrentes serão ignoradas.",
      "force_book": "Force Book",
      "force_booking_tooltip": "Todos os intervalos serão reservados, mesmo que haja um conflito. Use com cautela para evitar dupla reserva.",
      "book_next_available_tooltip": "Se um intervalo selecionado não estiver disponível, agende o próximo intervalo disponível na mesma programação recorrente (por exemplo, na próxima segunda-feira, se for semanal).",
      "slot_interval_tooltip": "Defina o intervalo entre os horários de início de slots consecutivos disponíveis. Por exemplo, se a duração da sua reunião for de 30 min e você definir o intervalo para 60 min, um usuário poderá agendar às 9h, depois às 10h e assim por diante — mesmo que cada reunião dure apenas 30 min.",
      "minimum_scheduling_notice_tooltip": "Exija que os usuários reservem reuniões com pelo menos esse tempo de antecedência.",
      "date_range_preferences_tooltip": "Defina até que ponto no futuro as reservas podem ser feitas a partir da data de hoje.",
      "maximum_bookings_per_slot_preferences_tooltip": "Limite quantas reuniões podem ser agendadas para o mesmo intervalo.",
      "maximum_bookings_per_slot_per_user_preferences_tooltip": "Limite quantas reuniões podem ser agendadas para o mesmo intervalo (por usuário).",
      "pre_buffer_time_tooltip": "Tempo para bloquear antes de cada reunião, permitindo tempo extra para se preparar.",
      "post_buffer_time_tooltip": "Tempo para bloquear após cada reunião, permitindo tempo extra para a conclusão.",
      "seats_per_class_tooltip": "Defina o número máximo de participantes permitidos para reservar esta aula. Assim que todos os assentos forem preenchidos, o intervalo de tempo não estará mais disponível para reserva.",
      "maximum_bookings_per_slot_per_user_tooltip": "Limite quantas reuniões podem ser agendadas para o mesmo intervalo (por usuário).",
      "repeat_frequency": "Frequência de repetição",
      "slot_interval": "Intervalo de slot",
      "skip_booking_helper_text": "Somente os intervalos disponíveis serão reservados. As datas indisponíveis na série de compromissos recorrentes serão ignoradas.",
      "force_book_helper_text": "Todos os intervalos serão reservados, mesmo que haja um conflito. Use com cautela para evitar dupla reserva.",
      "book_next_available_helper_text": "Se um intervalo selecionado não estiver disponível, Agendar o Próximo intervalo disponível Ativado a mesma programação recorrente (por exemplo, Próximo segunda-feira Se Semanalmente).",
      "bulk_edit": "Edição em massa",
      "select_users": "Selecionar usuários",
      "select_all": "Selecionar tudo",
      "times_to_repeat_tooltip": "Defina o número total de recorrências.",
      "custom_recurrence": "Recorrência personalizada",
      "repeats_every": "Repete a cada",
      "availability_schedule": "Programação de disponibilidade",
      "availability_schedule_desc": "Defina quando as reuniões podem ser marcadas com base na disponibilidade da equipe.",
      "no_users_added": "Nenhuma equipe foi adicionada!",
      "no_users_added_description": "Por favor, adicione a equipe para verificar a disponibilidade",
      "add_users": "Adicionar equipe",
      "minimum_scheduling_notice_error": "Insira ≤ 1.440 min.",
      "please_select_date": "Selecione uma data para continuar"
    },
    "forms_payment": {
      "forms": "Formulários e convidados",
      "forms_sub": "Configure as preferências para a página final que aparece após uma reserva bem-sucedida.",
      "select_form": "selecionar formulário",
      "enable_same_user_assignment": "Atribuir contatos aos respectivos membros do grupo de calendário cada vez que um compromisso é agendado.",
      "sticky_contacts_label": "{contactsLabel} fixo",
      "sticky_contacts": "Pré-preencher campos",
      "confirmation_page": "Página de confirmação",
      "default": "Padrão",
      "redirect_url": "URL de redirecionamento",
      "use_custom_form_rules": "Use regras de formulário personalizado",
      "default_message_tooltip": "Exibe a mensagem de confirmação configurada após o agendamento do compromisso.",
      "redirect_url_tooltip": "Redireciona o cliente para a página configurada após o agendamento do compromisso.",
      "use_custom_form_rules_tooltip": "Utiliza o redirecionamento ou a mensagem personalizada definida no formulário personalizado. Caso nenhuma regra se aplique, a mensagem de confirmação do calendário será exibida.",
      "thank_you": "Obrigado Mensagem",
      "enter_url": "Insira o URL",
      "enter_thank_you_message": "Insira a mensagem de agradecimento.",
      "amount_tab_hidden_label": "Placeholder da guia Valor",
      "percentage_tab_hidden_label": "Placeholder da guia Porcentagem",
      "pixel_id": "Meta Id do pixel (Opcional)",
      "auto_confirm": "Confirmar automaticamente novo compromissos de calendário",
      "configure_payment": "Configuração de pagamentos Opções",
      "accept_payments": "Aceitar pagamentos",
      "test": "Testar",
      "live": "Ao vivo",
      "enable_guests": "Adicionar convidados",
      "add_guest_tooltip": "Adicionar convidados permitirá que seu participante adicione vários participantes ao mesmo compromisso.",
      "add_guest_custom_form_tooltip": "Habilitar esta opção enviará um e-mail gerado pelo sistema aos convidados com um link para o formulário personalizado assim que o compromisso for confirmado. Para evitar e-mails duplicados, certifique-se de que um e-mail de confirmação separado ainda não esteja configurado para os convidados. (Verifique isso na aba de Notificações > Notificação de confirmação).",
      "add_guest_same_form_check": "Envie o mesmo formulário para coletar informações por e-mail para todos os convidados.",
      "payment_tooltip": "O pagamento só seria considerada para o PRINCIPAL Convidado e não para os convidados.",
      "default_form": "Padrão (nome, último nome, e-mail, Telefone, Notas)",
      "select_form_tooltip": "Se quiser coletar mais informações além do nome, sobrenome, e-mail e telefone padrão de quem reserva neste calendário, crie um formulário personalizado em Sites > Formulários > Construtor e selecione-o na lista suspensa abaixo.",
      "confirmation_page_tooltip": "Depois que alguém faz uma reserva, Você pode selecionar para exibir uma Mensagem personalizada ativada na mesma página (Padrão) ou redirecionar para uma página de sua escolha (Redirecionamento).",
      "add_guest_collect_email": "Nome e e-mail",
      "add_guest_count_only": "Contagem apenas",
      "custom_email_notification": "Envie formulário personalizado para os convidados.",
      "consent_label": "Caixa de seleção de Consentimento",
      "consent_input_placeholder": "Adicionar texto de consentimento",
      "same_user_assignment_tooltip": "Para habilitar esta configuração, o formulário deve ser primeiro ativado o Widget. Reagendar o Widget para Status do formulário primeiro para esta configuração de gatilho.",
      "consent_tooltip": "Solicite aos contatos que forneçam consentimento ao marcar uma reunião.",
      "stripe_error": "Até dois decimals ( Modelo: 25,99)",
      "auto_confirm_service": "Confirmar automaticamente novo compromisso",
      "service_form_message": "Se um contato estiver reservando vários serviços, ele verá apenas o formulário padrão no menu de serviços.",
      "deposit_amount_error": "O valor do pagamento deve ser menor que o valor Total .",
      "deposit_percentage_error": "A porcentagem do pagamento deve ser menor que 100\".",
      "partial_payment_tooltip": "Habilitar pagamentos incompletos para cobrar o valor do pagamento De Clientes durante o Pipeline de reserva de compromisso .",
      "partial_payment_enable_error": "O valor Total inserida deve ser maior que 0 para Habilitar pagamentos incompletos.",
      "payment_disable_text_integration": "Integre um provedor de pagamento em Pagamentos > Integrações para começar a aceitar pagamentos",
      "payment_disable_text_recurring": "Aceitar a opção de pagamento não está disponível para conferências Recorrente. Desabilitar Recorrente para pagamentos do Habilitar.",
      "date_and_time_selector": "Seletor de data e hora",
      "form_selector": "Formulário",
      "order_step": "Etapa",
      "widget_order_label": "Ordenar de Widget",
      "widget_order_tool_tip": "Reorganize a ordem do \"Seletor de data e hora\" e do \"Formulário\" no widget de calendário. Basta arrastar e reordenar de acordo com sua preferência.",
      "widget_re_order_tooltip": "A reordenação está disponível apenas com o estilo Neo Widget . Alterne para Neo para reordenar Habilitar.",
      "widget_re_order_disabled_tooltip": "Para reorganizar a ordem do widget, desative a opção \"Nova preferência de compromisso (sempre agendar com o usuário atribuído do {contactLabel})\" em Informações da conferência > Membros do grupo > Seção Configurações avançadas.",
      "payment_description_error": "Limite máximo de 1000 caracteres atingido.",
      "widget_multiple_location_disabled_tooltip": "O widget clássico não oferece suporte a vários locais de reunião. Por favor, remova as localizações adicionais para usar o widget clássico.",
      "recurring_payment_label": "Pagamento recorrente de compromisso",
      "enable_payments_for_guests": "Habilitar pagamentos para convidados",
      "guest_payment_description": "Como Você tem habilitado a opção \"Adição de convidados\", Você também pode selecionar a cobrança por Convidado Quando de reserva.",
      "charge_per_attendee": "Taxa por participante",
      "charge_per_attendee_description": "Multiplicar o valor Total Via o número de participantes (incluindo convidados) Ao cobrar o pagamento durante a reserva.",
      "click_confirm_description": "Clique em salvar para aplicar as alterações.",
      "multiply_amount_guests": "Cobrar pagamento para todos os participantes",
      "multiply_amount_guests_description": "Quando ativado, o valor a ser cobrado durante a reserva será multiplicado pelo número total de participantes, incluindo convidados.",
      "first_appointment_only": "cobrança apenas para o primeiro compromisso",
      "all_appointments": "cobrança para todos Compromisso inicial",
      "no_payment_provider_connected": "Nenhum provedor de pagamento conectado.",
      "no_default_payment_provider": "Nenhum pagamento Provedor conectado",
      "provider_not_supported": "O provedor de pagamento padrão não é compatível",
      "manage_payment_provider": "Gerenciar provedores de pagamento",
      "supported_providers": "Provedores compatíveis:",
      "paypal_razorpay_helper_text": "Os pagamentos serão processados somente via Razorpay, pois o PayPal não é compatível com provedores personalizados.",
      "rearrange_widget_order": "Reorganizar a ordem dos widgets",
      "change_form_order": "Dinâmico do formulário para a segunda etapa in Widget Ordenar desabilitará a configuração posterior:",
      "change_form_order_desc": "<b>Nova preferência de compromisso (sempre agendar com o usuário atribuído do {contactLabel})</b> será desabilitada. Isso significa que os compromissos podem ser agendados com qualquer membro do grupo disponível, em vez de serem limitados ao usuário atribuído do {contactLabel}.",
      "enable_mandatory_guest": "Criar adicionando pelo menos um Convidado Obrigatório. O Convidado Campos será pré-aberto e deve ser preenchido antes da reserva.",
      "enable_mandatory_guest_count": "Faça a contagem obrigatória de convidados no widget de reserva.",
      "require_guest_for_booking": "Exigir que os hóspedes reservem",
      "sticky_contacts_tooltip": "Campos de preenchimento automático para {contactsLabel} conhecidos.",
      "auto_confirm_tooltip": "Marcar automaticamente novas reuniões como confirmadas sem necessidade de aprovação manual. Desative esta opção se você deseja revisar e confirmar cada reserva manualmente antes que ela seja agendada.",
      "confirm_tooltip": "Assim que alguém fizer uma reserva, você pode optar por mostrar uma mensagem personalizada na mesma página (Padrão) ou redirecionar para uma página de sua escolha (URL de redirecionamento).",
      "facebook_pixel_id_tooltip": "",
      "accept_payments_tooltip": "Habilite a cobrança de pagamentos durante as reservas.",
      "total_amount_tooltip": "Defina a taxa total para a reunião.",
      "deposit_amount_tooltip": "Montante a ser coletado no momento da reserva como depósito.",
      "multiply_amount_guests_all_guests": "Cobrar pagamento para todos os participantes, incluindo convidados",
      "multiply_amount_guests_all_guests_tooltip": "Quando ativado, o valor a ser cobrado durante a reserva será multiplicado pelo número total de participantes, incluindo convidados.",
      "payment_description": "Descrição do pagamento",
      "payment_description_desc": "Exibido para o cliente ao inserir os detalhes de pagamento.",
      "payment_description_tooltip": "Opcionalmente, inclua os detalhes úteis sobre o pagamento.",
      "test_mode_warning": "Modo de teste Dinâmico - nenhuma venda real será processada.",
      "pixel_id_tooltip": "Envie atividades do widget de reserva, como visualizações, cliques e envios, para o Meta usando seu ID do Pixel.",
      "forms_description": "Defina suas preferências e configurações para coletar informações do cliente durante as reservas.",
      "payment_mode": "Modo de pagamento",
      "payment_mode_tooltip": "Alterne entre o modo de teste e o modo Ao vivo para pagamentos. in modo de teste, nenhum faturamento real é feito — use-o para estimar a reserva e o Pipeline de pagamento . Mude para o modo Ao vivo para aceitar pagamentos atuais De Clientes.",
      "enable_coupon": "Ativar códigos de cupom",
      "enable_coupon_tooltip": "Permita que os clientes apliquem códigos de cupom durante a reserva. Para garantir que funcionem, crie primeiro cupons válidos em Pagamentos > Códigos de cupom.",
      "guests": "Convidados"
    },
    "notifications": {
      "third_party_cal": "Configurações de calendários externos",
      "third_party_cal_desc": "Configure suas preferências para calendários externos.",
      "additional_settings": "Configurações adicionais",
      "additional_settings_desc": "Defina configurações adicionais para o seu calendário.",
      "notifications": "Notificações",
      "notifications_sub": "Configure como você envia notificações de reserva por e-mail, SMS, WhatsApp e alertas no aplicativo.",
      "edit": "Editar",
      "created_on": "Criado em",
      "updated_on": "Atualizado(a) em",
      "delivered": "Entregue",
      "not_available": "N/A",
      "select_notification_type": "Selecione o tipo de notificação.",
      "notification_person": "Quem deve Herdar esta notificação?",
      "contact": "{contactLabel}",
      "guest": "Convidado",
      "assigned_user": "Usuário atribuído",
      "emails": "Gmail",
      "alert_email_address": "Endereço de e-mail de Alerta",
      "ack_email": "E-mail de Reconhecimento",
      "send_google_invites": "Habilitar a Agenda Google para carregar o convite ou atualizar Gmail para os participantes.",
      "assign_user_to_contact_desc": "Quando ativado, o usuário atribuído ao {contactLabel} corresponderá ao proprietário do compromisso com a alteração mais recente — seja ele reservado, reagendado ou reatribuído.",
      "send_google_outlook_invites": "Permitir que o calendário do Google/Outlook/iCloud envie convites e e-mails de atualização aos participantes.",
      "assign_user_to_contact": "Atribua {contactsLabel} aos respectivos membros do grupo de calendário cada vez que um compromisso for agendado.",
      "skip_assigning_user_to_contact": "Pule a atribuição de {contactLabel} se o {contactLabel} já tiver um usuário atribuído.",
      "skip_assigning_user_to_contact_desc": "Quando ativado, o usuário atribuído ao {contactLabel} permanecerá o mesmo, mesmo que o proprietário do compromisso seja diferente.",
      "assigned_staff": "Equipe atribuída",
      "additional_emails": "Gmailadicional",
      "assign_user_to_staff": "Sempre atribua o contato ao proprietário do compromisso.",
      "allow_cancellation": " Permitir cancelamento da reunião",
      "allow_reschedule": "Permitir o reagendamento da reunião",
      "allow_cancellation_tooltip": "Quando Habilitado, um Link de cancelamento será adicionado à Seção de observações adicionais e incluído in convite do calendário. Este Link será o Vencido como configurado antes dos dados da conferência, evitar que o Agendador De cancel a conferência.",
      "allow_reschedule_tooltip": " Quando Habilitado, um Link de reprogramação será adicionado à Seção de observações adicionais e incluído in convite do calendário. Este Link será o Vencido como configurado antes dos dados de início da conferência, evitar que o Agendador De reagendar a conferência.",
      "cancellation_link_expiry": "O link de cancelamento irá expirar",
      "reschedule_link_expiry": "O link de reagendamento vai expirar",
      "before_meeting": "Antes da conferência",
      "cancellation_and_reschedule_policy": "Política de cancelamento e reagendamento:",
      "meeting_invite_notes": "Observações de convite para reunião",
      "meeting_invite_notes_tooltip": "Adicione observações que aparecerão no convite do calendário enviado aos clientes. Essas observações serão sincronizadas com calendários externos na descrição da reunião."
    },
    "connections": {
      "connections_heading": "Sincronização de calendário externo",
      "booking_channels_heading": "Canais de reserva",
      "booking_channels_description": "Configure como este calendário recebe agendamentos de plataformas externas.",
      "connections_sub": "Sincronize reuniões com calendários externos e gerencie o tratamento dos eventos.",
      "link_to_calendar": "Link para o calendário",
      "sync_option": "Opções de Sincronização",
      "execute_automation": "Executar automação",
      "fire_workflow": "Dispare gatilhos de fluxo de trabalho para eventos agendados via sincronização bidirecional.",
      "reserve_with_google": "Reserva com o Google [Descontinuado]",
      "reserve_with_google_setup": "Ver instruções de configuração",
      "reserve_with_google_configure": "Configuração",
      "change": "Alterar",
      "rwg_deprecation_notice": "O Google descontinuou o <b>Reserva com o Google (Anúncios de Serviços Locais)</b>. Novas conexões ou modificações nas conexões existentes não são mais aceitas. Para continuar recebendo reservas do Google, use <b>Reservas Orgânicas pelo Google</b>.",
      "rwg_category": "Categoria",
      "rwg_service_type": "Serviço",
      "connect_lsa": "Conecte-se à sua conta de anúncios de serviços locais.",
      "reserve_error": "O agora Agendar com Google é compatível com apenas para \"Empresa Serviços\", \"Real Estate\", \"LeGal Serviços\" (provedores de serviços locais) Empresa nicho in EUA.",
      "one_way": "Unidirecional",
      "two_way": "Bidirecional",
      "smart": "Inteligente",
      "confirm_remove": "Tem certeza de que deseja Extrair a Agenda Google ?",
      "read_only_access": "Você não tem acesso de gravação a este calendário. Selecione um calendário diferente.",
      "reserve_with_google_desc": "Este serviço de calendário será listado in Agendar com apenas Google Ativado Integração com êxito.",
      "check_integration": "Marca de verificação seu Status de integração",
      "setup_external": "Configurar calendário externo",
      "reserve_price_decimal_error": "Preço decimal não é suportado.",
      "reserve_price_max_error": "Preço suportado inferior a 1000.",
      "link_to_calendar_tooltip": "Selecione o calendário externo para sincronizar as reuniões. Os calendários do Google conectados nas Configurações do calendário → Conexões estão disponíveis para seleção.",
      "one_way_sync": "Unidirecional",
      "default_one_way": "Sincronização padrão (sincronização unidirecional)",
      "one_way_sync_desc": "Os eventos do calendário vinculado são sincronizados como intervalos bloqueados, e nenhum contato é criado para os convidados.",
      "two_way_sync": "Sincronização bidirecional",
      "two_way_sync_desc": "Contatos são criados para convidados encontrados em eventos de calendário vinculados, e esses eventos são transformados em compromissos do sistema.",
      "smart_sync": "Sincronização inteligente",
      "smart_sync_desc": "Os eventos do calendário vinculado são sincronizados como compromissos para os contatos existentes. Se nenhum contato existir, eles serão sincronizados como intervalos bloqueados sem criar um novo contato.",
      "sync_option_tooltip": "Escolha como os eventos do calendário externo são tratados:\n• Unidirecional: Bloqueia o tempo neste calendário sem criar {contactsLabel}\n• Bidirecional: Cria reuniões e {contactsLabel} a partir de eventos do calendário externo\n• Inteligente: Cria reuniões apenas para {contactsLabel} existentes e bloqueia tempo para os demais.",
      "default_sync": "Padrão",
      "default_sync_desc": "Sincroniza eventos do seu calendário externo com este calendário.",
      "advanced_sync": "Avançado",
      "advanced_sync_desc": "Sincroniza eventos do seu calendário externo com este calendário e cria contatos e compromissos no sistema.",
      "assign_contact_to": "Atribuir contato a",
      "select_calendar": "Selecionar calendário",
      "sync_preferences": "Preferências de sincronização",
      "sync_preferences_desc": "Como você gostaria de sincronizar seus eventos de calendário vinculados?",
      "recommended": "Recomendado",
      "execute_automation_desc": "Executar automação quando uma reunião for criada neste calendário.",
      "save": "Salvar alterações",
      "cancel": "Cancelar",
      "reserve_with_google_title": "Reservar com o Google",
      "current_connection": "Conexão atualmente ativa:",
      "category": "Categoria",
      "service": "Tipo de serviço",
      "price": "Preço estimado",
      "currency": "Moeda"
    },
    "booking_rules": {
      "booking_rules": "Regras de reserva",
      "booking_rules_description": "Controle como e quando as reuniões podem ser agendadas."
    },
    "payments": {
      "payments": "Pagamentos",
      "payments_description": " Habilite e gerencie pagamentos, regras e modelos de cobrança."
    },
    "extras": {
      "extras": "Personalizações",
      "extras_sub": "Estilo do Widget de coleção e outras configurações.",
      "calendar_widget_style": "Estilo do Widget de calendário",
      "neo": "Novo",
      "classic": "Clássico",
      "insert_custom_code": "Insira código personalizado",
      "show_seats_per_slot": "Exibir assinaturas por intervalo",
      "allow_reschedule_meeting": "Habilitar Reagendar Conferência",
      "allow_cancelling_meeting": "Habilitar cancelamento de conferência",
      "additional_notes": "Notas adicionais",
      "cancellation_and_reschedule": "Cancelamento e Reagendado:",
      "allow_staff": "Habilitar seleção de equipe durante a reserva",
      "code_block_tooltip": "Scripts de terceiros Interno o bloco HTML podem oferecer uma funcionalidade poderosa, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Portanto, recomendamos que Você para a avaliação do conteúdo deste código antes de salvá-lo para o calendário.",
      "calendar_image": "Imagem de capa do calendário",
      "remove_image": "Extrair imagem",
      "calendar_image_info": "A imagem carregada ficará visível na visualização de grupo do modelo Neo e não aparecerá no link individual do calendário.",
      "get_image_from_unsplash": "Melhore seu visual com",
      "unsplash": "Unsplash",
      "service_additional_preferences": "Configurar preferências adicionais",
      "service_image": "Imagem de capa do serviço",
      "service_image_description": "Selecione uma imagem que será exibida no menu de serviços para este serviço.",
      "allow_reschedule_appointment": "Habilitar Reagendar Compromisso",
      "allow_cancelling_appointment": "Habilitar cancelamento de compromisso",
      "custom_code_placeholder": "Por favor, feedback Código personalizado aqui",
      "calendar_widget_style_desc": "Escolha entre o nosso widget clássico ou o elegante widget Neo.",
      "seats_per_slot": "Assentos por intervalo",
      "show_staff_selection": "Seleção de equipe",
      "seats_per_slot_desc": " Habilitar o Agendador para pré-visualizar o número de Assentos disponíveis por janela de tempo diretamente ativado do Widget de calendário .",
      "show_staff_selection_desc": "Permita que os agendadores escolham um membro da equipe diretamente do widget de calendário ao agendar compromissos. Funciona apenas com o widget Neo.",
      "widget_re_order_tooltip": "O estilo clássico de widget não permite mudanças na ordem dos widgets. Certifique-se de que o Seletor de data e hora esteja em primeiro lugar e o Formulário em segundo antes de selecionar o estilo Clássico.",
      "show_staff_selection_desc_service": "Habilitar Agendador para selecionar uma equipe Membros diretamente do Widget de calendário durante a reserva de compromisso.",
      "switch_to_classic_widget": "Mude para o widget clássico",
      "switch_to_classic_widget_desc": "Alterar para o <b>widget clássico</b> desativará automaticamente as seguintes configurações, pois elas não podem coexistir:",
      "form_first_disabled": "<b>O formulário será movido para a segunda Etapa</b> in Ordenar do Widget .",
      "appointment_preference_disabled": "<b>Nova preferência de compromisso (sempre agendar com o usuário atribuído do {contactLabel})</b> será desabilitada. Isso significa que os compromissos podem ser agendados com qualquer membro do grupo disponível, em vez de serem limitados ao usuário atribuído do {contactLabel}.",
      "multiple_location_disabled": "<b>O endereço de várias conferências</b> será Apagado, e somente a <b>primeira localização adicionada</b> será retida.",
      "insert_custom_code_tooltip": "Personalize o estilo do widget utilizando seu próprio código CSS.",
      "classic_tooltip_disabled": "O widget clássico não é compatível com calendários de reserva de aulas.",
      "show_staff_selection_disabled_tooltip": "A seleção de pessoal é compatível apenas com o widget neo."
    },
    "roomsAndEquipments": {
      "title": "Selecione salas e equipamentos",
      "description": "Selecione em uma lista de salas e equipamentos o que será reservado junto com este calendário.",
      "rooms": "Selecione salas",
      "equipments": "Selecione o equipamento"
    }
  },
  "activity_log": {
    "activity_log": "Registro de atividades",
    "date": "Data",
    "filter_by": "Filtrar por",
    "calendar_update": "Atualização do calendário",
    "start_time_update": "Atualização do horário de início",
    "end_time_update": "Atualização da hora de término",
    "title_update": "Atualização de título",
    "notes_update": "Atualização de observações",
    "appointment_status_update": "Atualização do status do compromisso",
    "meeting_location_update": "Atualização da localização da reunião",
    "google_sync_update": "Atualização de sincronização do Google",
    "outlook_sync_update": "Atualização de sincronização do Outlook",
    "assigned_user_update": "Atualização do usuário designado",
    "appointment_status": "Status do compromisso",
    "assigned_user": "Usuário atribuído",
    "uploaded_to": "Carregado para",
    "cancelled": "Cancelado",
    "edited": "editado",
    "other_edits": "Outras edições",
    "view_details": "Visualizar detalhes",
    "all": "Todos"
  },
  "appointment_list": {
    "group_all": "TODOS",
    "group_primary": "PRINCIPAL",
    "group_user": "USUÁRIOS",
    "group_team": "GRUPOS",
    "group_calendar": "CALENDÁRIOS",
    "all_appointments": "Todos os compromissos",
    "my_calendar": "Meu calendário",
    "status_all": "Todos",
    "status_confirmed": "Confirmado",
    "status_new": "Novo(a) (ação necessária)",
    "status_show": "Comparecido",
    "status_no_show": "Não comparecimento",
    "status_cancelled": "Cancelado",
    "status_invalid": "Inválido",
    "filter_date_added_desc": "Data adicionada (desc)",
    "filter_start_added_desc": "Data de início (desc)",
    "filter_start_added_asc": "Data de início em ordem crescente a partir de hoje",
    "button_new_appointment": "Novo compromisso",
    "name": "Nome",
    "title": "Título",
    "requested_time": "Tempo solicitado",
    "date_added": "Data de adição",
    "calendar": "Calendário",
    "appointment_owner": "Proprietário do compromisso",
    "notes": "Observações",
    "status": "Status",
    "action_view_detail": "Visualizar detalhes",
    "action_view_consent": "Visualizar consentimento",
    "action_view_notes": "Visualizar observações",
    "action_edit": "Editar",
    "action_delete": "Excluir",
    "action_reschedule": "Reagendar",
    "page_previous": "Anterior",
    "page_next": "Seguinte",
    "appointment_notes": "Observações de compromisso",
    "close": "Fechar",
    "confirm_delete_header": "Apagar compromisso",
    "confirm_delete_message": "Tem certeza de que deseja excluir este compromisso? Essa ação não pode ser desfeita!",
    "confirm_delete_button": "Excluir",
    "confirm_update_header": "Atualizar status do compromisso",
    "confirm_update_confirmed_message": "Tem certeza de que deseja marcar este compromisso como confirmado?",
    "confirm_update_invalid_message": "Tem certeza de que deseja marcar este compromisso como inválido?",
    "confirm_update_showed_message": "Tem certeza de que deseja marcar este compromisso como comparecido?",
    "confirm_update_noshow_message": "Tem certeza de que deseja marcar esta consulta como não comparecimento?",
    "confirm_update_cancelled_message": "Tem certeza de que deseja marcar este compromisso como cancelado?",
    "confirm_update_button": "Atualizar",
    "empty_state_title": "Nenhum compromisso encontrado",
    "empty_state_description": "Nenhum compromisso encontrado.",
    "disable_menu_warning": "Você não tem autorização para visualizar ou editar os detalhes do compromisso, pois o contato associado não está atribuído a você. Contate seu administrador para obter ajuda.",
    "no_contact_warning": "Você não pode acessar as informações de contato no momento. Isso pode ocorrer porque o contato não está atribuído a você. Entre em contato com seu administrador para obter ajuda.",
    "consent_label": "Consentimento",
    "ip_address": "IP",
    "youre_viewing_in": "Atualmente visualizando em",
    "appointment_delete_msg": "<b>Observação:</b> O compromisso excluído daqui não será excluído do Calendly.",
    "rescheduled": "Reagendado"
  },
  "add_guest": {
    "guest_label": "Convidado(s)",
    "search_placeholder": "Pesquisar de Amigos",
    "add_new": "Adicionar novo(a)",
    "save": "Arquivar",
    "close": "Fechar",
    "name": "Nome",
    "phone": "Telefone",
    "email": "E-mail",
    "guest_label_count": "Contagem de Convidado(s)",
    "guest_count_error": "O Convidado Contagem deve estar entre 1 e 100"
  },
  "languages": {
    "danish": "Danish",
    "dutch": "Dutch",
    "english": "English",
    "finnish": "Finnish",
    "french": "French",
    "french_canada": "French (Canada)",
    "german": "German",
    "hungarian": "Hungarian",
    "italian": "Italian",
    "norwegian": "Norwegian",
    "polish": "Polish",
    "portuguese_brazil": "Portuguese (Brazil)",
    "portuguese_portugal": "Portuguese (Portugal)",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "turkish": "Turkish"
  },
  "service_menu_advanced": {
    "new_service_menu_details_header": "Detalhes do menu de serviço",
    "select_groups_header": "Selecionar serviços",
    "arrange_groups_header": "Configuração seus serviços",
    "new_service_menu": "Novo menu de serviços",
    "service_menu_sub_title": "Crie um menu de serviço personalizado para seus clientes in apenas alguns cliques",
    "quick_tip": "Você pode Incluir Grupo ao menu de serviços",
    "service_menu_name": "Nome do menu de serviços",
    "service_menu_description": "Descrição",
    "service_menu_slug": "URL do serviço",
    "select_groups_calendars": "selecionar grupo e calendários",
    "select_groups_calendars_desc": "Adicione serviços ao seu menu de serviços.",
    "select_all": "Selecionar tudo",
    "arrange_groups": "Configuração ordenada de serviços",
    "arrange_groups_desc": "determinar o Pipeline de serviços ativado o menu de serviços",
    "arrange_services_quicktip": "Para Reagendar calendários dentro do Grupo, acesse Grupo > Opções > Reagendar Calendários.",
    "enable_add_guest_desc": "Habilitar clientes para incluir convidados adicionais ao fazer uma reserva.",
    "enable_multiple_service_desc": "Habilitar clientes para agendar vários serviços in um compromisso individuais.",
    "enable_staff_selection_desc": "Habilitar clientes para selecionar a equipe preferida Membros Quando fazer uma reserva.",
    "enable_add_guest": "Habilitar adicionar convidados",
    "enable_multiple_service": "Habilitar seleção de vários serviços",
    "enable_staff_selection": "Habilitar seleção de equipe",
    "additional_options": "Opções adicionais",
    "code_block_tooltip": "Scripts de terceiros Interno o bloco HTML podem oferecer uma funcionalidade poderosa, mas também trazem riscos à privacidade, segurança, desempenho e comportamento da página. Portanto, recomendamos que Você para a avaliação do conteúdo deste código antes de salvá-lo ao menu de serviço.",
    "custom_code_placeholder": "Por favor, feedback Código personalizado aqui",
    "insert_custom_code": "Insira código personalizado",
    "no_service": "Nenhum serviço encontrado",
    "no_service_desc": " Nenhum serviço encontrado. Criar Serviços e Incluir para o Grupo para Criar um menu de serviços.",
    "learn_more": "Saiba mais",
    "no_service_selected": "Nenhum serviço selecionado",
    "create_service_calendars": "Criar calendários de serviços",
    "alert_description": " Para criar um menu de serviços, é necessário criar calendários de serviço e adicioná-los aos grupos.",
    "dont_show_again": "Não exibir isto novamente",
    "service_name_required": "É necessário o nome do menu de serviço.",
    "slug_already_taken": "Este Slug já está disponível",
    "slug_required": "Slug é obrigatório",
    "please_enter_name": "Digite um nome",
    "service_name_placeholder": "Menu principal",
    "service_slug_placeholder": "menu principal",
    "form_label": "Formulário",
    "consent_label": "Caixa de seleção de Consentimento",
    "consent_input_placeholder": "Adicionar texto de consentimento",
    "consent_tooltip": "Alterne esta opção para permitir a obtenção de consentimento do {contactsLabel} quando eles fornecerem seu número de telefone durante o fluxo de trabalho de agendamento de compromissos.",
    "back_message": "Voltar à lista",
    "saving_changes": "Apenas um minuto — Salvando o Dinâmico mais recente...",
    "payment_provider_warning": "Aviso! Os menus de serviço agora suportam pagamentos apenas via Stripe e Authorize.net. Como seu provedor padrão é diferente, a cobrança de pagamentos para calendários selecionados com pagamentos ativados será ignorada.",
    "aria": {
      "consent_form_toggle": "Alternância do formulário de consentimento",
      "enable_add_guest_toggle": "Habilitar alternância para adicionar convidado",
      "enable_multiple_services_toggle": "Habilitar alternância de vários serviços",
      "enable_staff_selection_toggle": "Habilitar alternância de seleção de equipe"
    }
  },
  "widget_configuration": {
    "customise_calendar_widget": "Personalizar Widget de calendário",
    "works_with_neo_widget": "Funciona só com o Widget Neo",
    "customise_widget_desc": "Personalizar Aparência do Widget : PRINCIPAL Cor, Plano de fundo Cor e Botão Corpo.",
    "learn_more": "Saiba mais",
    "primary_settings": "PRINCIPAL configurações",
    "primary_settings_desc": "Configure a cor primária, a cor de fundo e outras preferências do widget para personalizar seu widget de calendário.",
    "primary_color": "PRINCIPAL Cor",
    "primary_color_desc": "Defina a cor para botões, datas, intervalos de tempo e ações.",
    "background_color": "Cor de Plano de fundo",
    "background_color_desc": "Coleção o Plano de fundo Cor que funciona como pano de fundo para o seletor de data e hora e o formulário.",
    "button_text": "Texto do botão",
    "button_text_desc": "Personalize o texto exibido no botão ao marcar um compromisso.",
    "calendar_title": "Título do calendário",
    "calendar_title_desc": "O nome do seu calendário",
    "calendar_description": "Descrição do calendário",
    "calendar_description_desc": "A descrição inserida.",
    "calendar_details": "Detalhes do calendário",
    "calendar_details_desc": "Inclui informações como duração, data e hora, detalhes recorrentes e fuso horário.",
    "reset_to_default": "Redefinir para o padrão",
    "preview_widget": "Pré-visualizar widget",
    "calendar_title_tooltip": "Defina se o nome do calendário e o nome do grupo (se aplicável) devem ser visíveis no widget de reserva.",
    "calendar_description_tooltip": "Defina se a descrição do calendário deve ser visível no widget de agendamento.",
    "calendar_details_tooltip": "Coleção Se os detalhes das Reuniões de Chave, como Conferência Duração, Dados e dados selecionados e informações de recorrência (se aplicável) devem estar visíveis Ativado o Widget de agendamento.",
    "insert_custom_code_tooltip": "Personalizar estilo do Widget Via seu próprio código CSS .",
    "staff_selection_tooltip": "Habilitar Agendador para selecionar uma equipe Membros diretamente do Widget de calendário durante a reserva de compromisso. Funciona somente com o Neo Widget."
  },
  "eventNotification": {
    "customFields": "Campos personalizados",
    "customValues": "Valores personalizados",
    "guest": "Convidado",
    "assignedUser": "Usuário atribuído",
    "additionalEmails": "E-mails adicionais",
    "list": {
      "booked": {
        "title": "Compromisso agendado (Status: não confirmado)",
        "modalTitle": "compromisso agendado (Status: não confirmado)",
        "note": "Esta notificação é enviada quando um novo compromisso é criado com o status de não confirmado.",
        "subTitle": "Envia uma notificação quando um compromisso é agendado com o status de não confirmado."
      },
      "confirmation": {
        "title": "Compromisso agendado (Status: confirmado)",
        "modalTitle": "compromisso agendado (status: confirmado)",
        "note": "Esta notificação é enviada quando um compromisso é criado ou atualizado para o status de confirmado.",
        "subTitle": "Envia uma notificação quando um compromisso é confirmado com sucesso."
      },
      "cancellation": {
        "title": "Cancelamento",
        "modalTitle": "cancelamento",
        "note": "Esta notificação é enviada quando um compromisso é cancelado, marcado como não comparecimento ou marcado como inválido.",
        "subTitle": "Envia um alerta quando um compromisso é cancelado."
      },
      "reschedule": {
        "title": "Reagendar",
        "modalTitle": "reagendar",
        "note": "Esta notificação é enviada Quando um compromisso é reagendado. Ele só será acionado se o compromisso estiver in Status de não confirmado ou confirmado .",
        "subTitle": "Notifica quando um compromisso é reagendado."
      },
      "reminder": {
        "title": "Lembrete",
        "modalTitle": "lembrete",
        "note": "Esta notificação é enviada como Lembrete antes do compromisso. Ele só será acionado se o compromisso estiver in Status de não confirmado ou confirmado .",
        "subTitle": "Envia um lembrete antes do compromisso."
      },
      "followup": {
        "title": "Acompanhamento",
        "modalTitle": "acompanhamento",
        "note": "Esta notificação é enviada após o compromisso como um acompanhamento. Ela só será acionada se o compromisso estiver no status de não confirmado, confirmado ou comparecido.",
        "subTitle": "Envia uma mensagem de acompanhamento após a conclusão do compromisso."
      }
    },
    "saveToastMsg": "Configurações salvas!",
    "saveToastMsgDesc": "Suas alterações foram salvas com sucesso.",
    "enableSuccess": "Notificações habilitadas!",
    "disableSuccess": "Notificações desabilitadas!",
    "tooltip": "Esta notificação foi desabilitada. Habilite-a para fazer alterações.",
    "enabled": "Habilitado(a)",
    "disabled": "Desabilitado(a)",
    "statusLabel": "Rótulos de status",
    "email": {
      "channelName": "E-mail",
      "noneTemplate": "Nenhum",
      "notificationLabel": "Quem deve receber esta notificação?",
      "sendButtonLabel": "Enviar e-mail de teste",
      "testEmailLabel": "Email de teste",
      "testEmailPlaceholder": "Insira o endereço de e-mail do destinatário para teste",
      "body": "Corpo do e-mail",
      "bodyPlaceholder": "Digite sua mensagem aqui",
      "subject": "Assunto",
      "subjectPlaceholder": "Insira o assunto do e-mail",
      "templateLabel": "Modelo de e-mail",
      "templatePlaceholder": "Selecione um modelo de e-mail ou comece do zero",
      "fromNamePlaceholder": "Inserir nome",
      "fromNameLabel": "Do nome",
      "fromAddressLabel": "Do endereço",
      "alertEmailAddress": "Insira IDs de e-mails (separados por vírgulas)",
      "addMore": "Adicionar mais",
      "afterAppointmentEnds": "após o término do compromisso",
      "beforeAppointmentStarts": "antes do início do compromisso",
      "durationLabel": "Quando você gostaria de acionar a notificação?",
      "disableEmailNotification": "Desabilitar notificações por e-mail",
      "enableEmailNotification": "Habilitar notificações por e-mail",
      "enableSuccess": "Notificação por e-mail habilitada!",
      "enableSuccessDesc": "Agora você começará a receber esta notificação",
      "disableSuccess": "Notificação por e-mail desativada!",
      "disableSuccessDesc": "Você não receberá mais esta notificação",
      "reset_to_default": "Redefinir para o padrão",
      "testEmailSuccessTitle": "E-mail de teste enviado!",
      "testEmailSuccessDesc": "O e-mail de teste foi enviado com sucesso para {email}",
      "testEmailErrorTitle": "Falha ao enviar e-mail de teste",
      "testEmailErrorDesc": "Houve um erro ao enviar o e-mail de teste. Tente de novo.",
      "create_new_email_template": "Criar novo modelo de e-mail",
      "templateVariableFieldSubject": "Linha de assunto",
      "templateVariableFieldFromName": "Do nome",
      "templateVariableFieldFromAddress": "Do endereço",
      "templateVariableFieldEmailBody": "Corpo do e-mail"
    },
    "inApp": {
      "channelName": "No app",
      "title": "Configurações de notificação",
      "enableInAppNotification": "Habilitar notificação no aplicativo",
      "disableInAppNotification": "Desabilitar notificação no app",
      "selectedUser": {
        "label": "Enviar para",
        "helperText": "Esta notificação interna é enviada pela web e por aplicativos móveis.",
        "placeholder": "Selecionar usuários"
      },
      "enableSuccess": "Notificações no aplicativo ativadas!",
      "enableSuccessDesc": "Agora você começará a receber esta notificação.",
      "disableSuccess": "Notificações no app desabilitadas!",
      "disableSuccessDesc": "Você não receberá mais esta notificação."
    },
    "sms": {
      "channelName": "SMS",
      "noneTemplate": "Nenhum",
      "notificationLabel": "Quem deve receber esta notificação?",
      "sendButtonLabel": "Enviar SMS de teste",
      "testSMSLabel": "Teste de SMS (insira o número de telefone com código do país)",
      "testSMSPlaceholder": "+12345678901",
      "body": "Mensagem SMS",
      "bodyPlaceholder": "Digite sua mensagem SMS aqui",
      "durationLabel": "Quando você gostaria de acionar a notificação?",
      "disableSMSNotification": "Desabilitar notificações por SMS",
      "enableSMSNotification": "Habilitar notificações por SMS",
      "enableSuccess": "Notificação por SMS habilitada!",
      "enableSuccessDesc": "Agora você começará a receber esta notificação.",
      "disableSuccess": "Notificação por SMS desabilitada!",
      "disableSuccessDesc": "Você não receberá mais esta notificação.",
      "alertPhoneNumbers": "Insira números de telefone (com códigos de país, separados por vírgulas)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Adicionar mais",
      "afterAppointmentEnds": "após o término do compromisso",
      "beforeAppointmentStarts": "antes do início do compromisso",
      "templateLabel": "Modelo de SMS",
      "templatePlaceholder": "Selecione o modelo de SMS...",
      "reset_to_default": "Redefinir para o padrão",
      "testSmsSuccessTitle": "SMS de teste enviado!",
      "testSmsSuccessDesc": "O SMS de teste foi enviado com sucesso para {phone}.",
      "testSmsErrorTitle": "Falha ao enviar SMS de teste",
      "testSmsErrorDesc": "Houve um erro ao enviar o SMS de teste. Tente de novo.",
      "templateVariableFieldSmsBody": "Corpo da mensagem"
    },
    "whatsapp": {
      "channelName": "WhatsApp",
      "notificationLabel": "Quem deve receber esta notificação?",
      "sendButtonLabel": "Enviar notificação de teste do WhatsApp",
      "testWhatsAppLabel": "Teste de notificação por WhatsApp (insira o número de telefone com o código do país)",
      "testWhatsAppPlaceholder": "+12345678901",
      "durationLabel": "Quando você gostaria de acionar a notificação?",
      "alertPhoneNumbers": "Insira números de telefone (com códigos de país, separados por vírgulas)",
      "alertPhoneNumbersPlaceholder": "+12345678901, +447123456789",
      "addMore": "Adicionar mais",
      "afterAppointmentEnds": "após o término do compromisso",
      "beforeAppointmentStarts": "antes do início do compromisso",
      "templateLabel": "Modelo do WhatsApp",
      "templatePlaceholder": "Selecione o modelo do WhatsApp...",
      "noPreview": "Nenhum modelo selecionado",
      "templateRequired": "Modelo necessário",
      "testWhatsAppSuccessTitle": "Notificação de teste do WhatsApp enviada!",
      "testWhatsAppSuccessDesc": "A notificação de teste por WhatsApp foi enviada com sucesso para {phone}.",
      "testWhatsAppErrorTitle": "Falha ao enviar notificação de teste por WhatsApp.",
      "testWhatsAppErrorDesc": "Ocorreu um erro ao enviar a notificação de teste por WhatsApp. Tente novamente.",
      "setupTitle": "Entre em contato com o seu cliente no aplicativo de mensagens favorito dele.",
      "setupDescription": "Mantenha-se mais próximo de seus clientes fornecendo suporte instantâneo, enviando atualizações oportunas e criando interações envolventes.",
      "connectWhatsApp": "Conectar o WhatsApp",
      "checkingStatus": "Verificando o status da conta do WhatsApp...",
      "checkingTemplateStatus": "Verificando o status do modelo do WhatsApp...",
      "statusCheckError": "Falha ao verificar o status da conta do WhatsApp.",
      "templateStatusCheckError": "Falha ao verificar o status do modelo do WhatsApp.",
      "setupTemplateTitle": "Conclua a configuração do seu modelo de WhatsApp.",
      "setupTemplateDescription": "Você precisa configurar modelos do WhatsApp antes de poder enviar notificações. Clique abaixo para concluir o processo de configuração.",
      "loadTemplatesError": "Falha ao carregar modelos do WhatsApp.",
      "templatesRefreshed": "Modelos atualizados com sucesso",
      "templatesRefreshError": "Falha ao atualizar modelos.",
      "templatesResolveError": "Erro ao resolver os modelos padrão do WhatsApp.",
      "locationNotFound": "ID de localização não encontrado.",
      "settingsRedirectError": "Não foi possível redirecionar para as configurações do WhatsApp.",
      "updateNotificationError": "Falha ao atualizar notificação por WhatsApp.",
      "notificationsEnabled": "Notificações por WhatsApp habilitadas!",
      "notificationsDisabled": "Notificações por WhatsApp desabilitadas!",
      "updateError": "Erro ao atualizar notificações.",
      "createNewTemplate": "Criar novo modelo do WhatsApp",
      "phoneValidation": {
        "countryCodeRequired": "O número de telefone deve começar com um código do país (por exemplo, +1, +91, +44)",
        "digitsOnly": "O número de telefone deve conter apenas dígitos após o código do país.",
        "tooShort": "O número de telefone é muito curto.",
        "tooLong": "O número de telefone é muito longo.",
        "invalid": "Número de telefone inválido."
      },
      "errors": {
        "templateNotFound": "ID do modelo não encontrado nas opções carregadas, limpando.",
        "templateNoLongerValid": "Modelo salvo não mais válido, limpando.",
        "invalidTemplateSelection": "Tentativa de selecionar um modelo do WhatsApp inválido.",
        "fetchingTemplates": "Erro ao buscar modelos do WhatsApp.",
        "mountingCreator": "Erro ao montar o Criador de modelos do WhatsApp.",
        "fetchingAfterCreation": "Erro ao buscar modelos do WhatsApp após a criação.",
        "updateStatus": "Erro ao atualizar o status do WhatsApp."
      },
      "receiverLabels": {
        "assignedUser": "Usuário atribuído",
        "phoneNumbers": "Números de telefone adicionais"
      }
    },
    "templateVariableIssueDefaultPartBefore": "Há problemas com seu(s) ",
    "templateVariableIssueDefaultPartHighlight": "valores personalizados",
    "templateVariableIssueDefaultPartAfter": "Revise e corrija-os antes de salvar.",
    "templateVariableInvalidListOverflow": "… e {count} mais",
    "templateVariableIssueSingle": "Há um problema com este valor personalizado: {value}; corrija-o antes de salvar.",
    "templateVariableIssueEmpty": "Um ou mais valores personalizados estão vazios ({emptyPair}); adicione um campo válido dentro dos colchetes.",
    "templateVariableIssueMarkup": "Alguns valores personalizados incluem HTML ou formatação, o que não é suportado; remova-os antes de salvar.",
    "templateVariableSaveFailed": "Não foi possível salvar a notificação {receiverLabel}. Corrija os erros de valores personalizados antes de salvar.",
    "templateVariableSaveFailedGeneric": "Não foi possível salvar a notificação. Corrija os erros de valores personalizados antes de salvar."
  },
  "smsTemplate": {
    "create_new_template": "Criar novo modelo de SMS",
    "create_new_template_desc": "Crie um modelo de SMS reutilizável para suas notificações.",
    "template_name": "Nome do modelo",
    "template_name_placeholder": "Insira o nome do modelo",
    "message": "Mensagem",
    "message_placeholder": "Digite sua mensagem SMS aqui.",
    "create_template": "Criar modelo",
    "name_required": "O nome do modelo é obrigatório",
    "text_required": "O texto da mensagem é obrigatório",
    "fetch_new_templates": "Atualizar modelos",
    "characters": "caracteres",
    "words": "palavras",
    "segments": "s"
  },
  "whatsappTemplate": {
    "create_new_template": "Criar novo modelo do WhatsApp",
    "create_new_template_desc": "Crie um modelo do WhatsApp reutilizável para suas notificações.",
    "template_name": "Nome do modelo",
    "template_name_placeholder": "Insira o nome do modelo",
    "message": "Mensagem",
    "message_placeholder": "Digite aqui sua mensagem do WhatsApp.",
    "create_template": "Criar modelo",
    "name_required": "O nome do modelo é obrigatório",
    "text_required": "O texto da mensagem é obrigatório",
    "fetch_new_templates": "Atualizar modelos"
  },
  "archivedServices": {
    "servicesBanner": "Uma nova versão aprimorada dos serviços está aqui — mais poderosa, flexível e intuitiva. Seus calendários de serviços já foram migrados. Explore-os agora na guia Serviços.",
    "archivedServiceCalendars": "Calendários de serviço (v1)",
    "check_new_services": "Confira novos serviços"
  },
  "tour": {
    "hidden_test_label": "Testar",
    "calendar": {
      "edit_calendar": "Editar calendário",
      "share_calendar": "Compartilhar calendário",
      "troubleshoot_calendar": "Solucionar problemas de calendário",
      "more_options": "Mais opções",
      "edit_calendar_desc": "Gerenciar todas as configurações do calendário - Fixa Disponibilidade, Configuração Lembrete, Modificar limite de compromisso e muito mais.",
      "share_calendar_desc": "Copie e compartilhe seu Link de programação para que o Agendador possa programar facilmente com Você.",
      "troubleshoot_calendar_desc": "Descubra por que um intervalo não está sendo exibido e visualize os possíveis motivos na solução de problemas.",
      "more_options_desc": "Acesso configurações e atividades adicionais para gerenciar seu calendário.",
      "read_permissions": {
        "share_description": "Conceda acesso a outras pessoas compartilhando o link do calendário ou ajustando as permissões.",
        "troubleshoot_description": "Identifique e resolva problemas como erros de sincronização ou eventos ausentes para uma funcionalidade uniforme."
      },
      "next": "Próximo",
      "start_over": "Recomece",
      "all_set": "Tudo pronto!",
      "previous": "Anterior"
    }
  },
  "emailTemplate": {
    "select_editing_experience": "Selecione sua experiência de edição",
    "select_editing_experience_desc": "Escolha Criar usando nosso Editor de Design Visual com recurso de arrastar e soltar ou nosso poderoso Editor de Código.",
    "design_editor": "Editor de design",
    "design_editor_desc": "Edição visual de arrastar e soltar.",
    "code_editor": "Editor de código",
    "code_editor_desc": "Edição de HTML com muitos recursos.",
    "text_editor": "Editor de código simples",
    "text_editor_desc": "Edição de texto básica, limpa e sem frescuras.",
    "email_text_block": "O e-mail também pode ser bloco Criado Via Corpo. ",
    "select": "Selecionar",
    "new_template": "Novo modelo",
    "email_block": "O e-mail também pode ser criado usando um bloco de texto.",
    "fetch_new_templates": "Buscar novos modelos"
  },
  "quick_tips": {
    "meeting_details": {
      "clear_name_and_description": "Use um nome e uma descrição claros para a reunião, para que os agendadores saibam exatamente o que estão programando.",
      "groups_share_link": "Grupos permitem que você compartilhe um único link de programação para múltiplos calendários, permitindo que os clientes escolham e reservem entre as opções disponíveis."
    },
    "staff_location": {
      "custom_location": "Selecione \"Personalizado\" como local de encontro para inserir qualquer endereço ou link de sua escolha.",
      "ask_booker_location": "Quando a opção \"Perguntar ao responsável pela reserva\" é selecionada, o responsável pela reserva é solicitado a inserir o local da reunião durante a reserva",
      "round_robin_priority": "As configurações de prioridade influenciam a distribuição das reuniões quando há vários membros da equipe disponíveis.",
      "connect_video_integrations": "Conecte as integrações de videoconferência em Configurações do calendário → Conexões antes de selecioná-las como local da reunião."
    },
    "availability": {
      "staff_availability_required": "As reuniões só podem ser marcadas quando pelo menos um membro da equipe selecionado estiver disponível.",
      "use_precreated_schedule": "Você pode usar uma programação de disponibilidade pré-criada nas configurações do calendário → Disponibilidade ou criar uma programação personalizada apenas para este calendário.",
      "timezone_in_schedule": "O fuso horário para as reuniões é configurado dentro da programação de disponibilidade selecionada.",
      "event_24_hours": "Para tornar o calendário disponível 24 horas, defina o intervalo de tempo de 00:00 às 00:00."
    },
    "booking_rules": {
      "apply_to_all_meetings": "As regras de agendamento aplicam-se a todas as reuniões neste calendário, independentemente da disponibilidade dos funcionários.",
      "minimum_scheduling_notice": "Aumente o aviso mínimo de programação para evitar reservas de última hora.",
      "maximum_bookings_per_slot": "Use o máximo de reservas por intervalo para controlar quantas reuniões podem acontecer ao mesmo tempo."
    },
    "forms": {
      "custom_contact_fields": "Você pode incluir campos de contato personalizados tanto nas mensagens quanto nos URLs do formulário.",
      "create_custom_form": "Para coletar mais informações, crie um formulário personalizado em Sites → Forms → Builder e utilize-o com este calendário."
    },
    "payments": {
      "collected_during_booking": "Os pagamentos são recolhidos durante a reserva e devem ser concluídos antes que a reunião seja confirmada.",
      "payment_description": "Use a descrição do pagamento para explicar claramente para que serve a cobrança."
    },
    "notifications": {
      "review_policies": "Revise as políticas de cancelamento e remarcação para evitar alterações de última hora.",
      "use_workflows": "Para automação avançada, use fluxos de trabalho com o gatilho \"Compromisso agendado\"."
    },
    "customizations": {
      "preview_widget": "Pré-visualize o widget para garantir que ele esteja alinhado com sua marca e fluxo de reservas.",
      "update_widget_language": "As configurações de idioma do widget podem ser alteradas em Configurações → Calendários → Preferências."
    },
    "connections": {
      "google_organic_booking": "Configurar o recurso de reservas orgânicas do Google permite que este calendário receba reservas diretamente da Busca do Google.",
      "external_sync_event": "Apenas o calendário selecionado em Sincronização externa é utilizado para buscar e enviar eventos para este calendário."
    },
    "equipments": {
      "room_definition": "Uma \"sala\" pode representar qualquer local onde serviços são fornecidos. Podem ser salas físicas e/ou estações dedicadas. Ex.: Estação de pedicure.",
      "equipment_definition": "\"Equipamento\" são ferramentas ou dispositivos que as empresas usam para cumprir compromissos. Podem incluir máquinas, dispositivos ou mesmo cadeiras."
    }
  },
  "aria_labels": {
    "sticky_contacts": "Contatos fixos",
    "consent_form": "Formulário de Consentimento",
    "enable_guests": "Habilitar convidados",
    "auto_confirm": "Confirmação automática",
    "should_accept_payment": "Deve aceitar pagamento",
    "collect_deposit": "Coletar depósito",
    "enable_charge_guests": "Habilitar cobrança de convidados",
    "enable_coupon": "Ativar cupom",
    "payment_live": "Pagamento ao vivo",
    "add_availability_hour": "Adicionar hora de disponibilidade",
    "remove_availability_hour": "Remover horário de disponibilidade",
    "copy_availability_hour": "Copiar horário de disponibilidade",
    "close_modal": "Fechar modal",
    "add_custom_slot": "Adicionar intervalo personalizado",
    "remove_custom_slot": "Remover intervalo personalizado",
    "edit_custom_slot": "Editar intervalo personalizado",
    "update_frequency": "Atualizar frequência",
    "show_calendar_title": "Exibir título do calendário",
    "show_calendar_description": "Exibir descrição do calendário.",
    "show_calendar_details": "Mostrar detalhes do calendário",
    "allow_reschedule": "Permitir reagendamento",
    "allow_cancellation": "Permitir cancelamento",
    "category_actions": "Ações da categoria",
    "show_seats_per_slot": "Mostrar assentos por intervalo",
    "add_more": "Adicionar mais",
    "same_user_assignment_toggle": "Alternar atribuição do mesmo usuário"
  },
  "placeholders": {
    "pixel_id": "ID do pixel",
    "select_one": "Selecionar um",
    "meeting_location": "Localização da reunião",
    "schedule_meeting": "Agendar reunião",
    "notes": "Notas",
    "select_users": "Selecionar usuários",
    "please_select": "Selecione"
  },
  "alt_text": {
    "payment_provider": "Provedor de pagamento",
    "no_calendars": "Sem calendários",
    "date_specific_hours": "horas específicas da data",
    "custom_widget_image": "Imagem de widget personalizado",
    "service_calendar": "Calendário de serviço",
    "event_calendar": "Calendário de eventos",
    "round_robin_booking": "Agendamento por rodízio",
    "class_booking": "Agendamento de aulas",
    "collective_booking": "Reserva coletiva",
    "calendar_cover_image": "Imagem de capa do calendário",
    "email_notification_switch": "Alternar notificações por e-mail",
    "email_template_icon": "Ícone do modelo de e-mail",
    "in_app_notification_switch": "Alternar notificação no aplicativo",
    "sms_notification_switch": "Alternar notificação por SMS",
    "whatsapp_notification_switch": "Alternar notificação do WhatsApp",
    "no_service_found": "Nenhum serviço encontrado",
    "no_group_found": "Nenhum grupo encontrado",
    "sync_icon": "Ícone de sincronização",
    "sync_type": "Tipo de sincronização",
    "test1": "teste1",
    "test2": "teste2"
  },
  "tooltips": {
    "text_color": "Cor do texto",
    "background_color": "Cor do plano de fundo",
    "strikethrough": "Tachar",
    "superscript": "Sobrescrito",
    "subscript": "Subscrito",
    "inline_code_block": "Bloco de código embutido",
    "code_block": "Bloco de código",
    "block_quote": "Citação em bloco",
    "more": "Mais",
    "upload": "Carregar",
    "image_upload_tooltip": "PNG, JPEG, JPG ou GIF (máx. dimensões 180x180px | máx. tamanho 2,5 MB).",
    "custom_values": "Valores personalizados",
    "text_wrap": "Quebra de texto",
    "trigger_links": "Links de acionamento",
    "text_align": "Alinhamento de texto"
  },
  "labels": {
    "reset_style": "Redefinir estilo",
    "reset_document_style": "Redefinir estilo do documento",
    "source_code": "Código-fonte",
    "success": "Sucesso",
    "edit": "Editar",
    "submit": "Salvar",
    "cancel": "Cancelar",
    "payment": "Pagamento",
    "here_is_the_link": "Aqui está o link:",
    "here_is_the_embed_code": "Aqui está o código de incorporação:",
    "service_calendar": "Calendário de serviços",
    "collective_booking": "Reserva Coletiva",
    "class_booking": "Agendamento de aulas",
    "round_robin_booking": "Agendamento por rodízio",
    "event_calendar": "Calendário de eventos",
    "personal_booking": "Agendamento pessoal",
    "service_booking": "Agendamento de serviço",
    "calendar_id": "ID do calendário"
  },
  "validation_messages": {
    "calendar_group_name_required": "O nome do grupo de calendário é obrigatório.",
    "calendar_group_description_required": "A descrição do grupo de calendário é obrigatória.",
    "slug_required": "O slug é obrigatório.",
    "slug_not_valid": "Este slug não é válido.",
    "slug_already_taken": "Este slug já está em uso.",
    "error_validating_slug": "Erro ao validar slug.",
    "please_enter_name": "Insira um nome.",
    "room_name_required": "O nome da sala é obrigatório",
    "equipment_name_required": "O nome do equipamento é obrigatório.",
    "subject_required": "O assunto é obrigatório.",
    "this_is_required": "Isto é necessário.",
    "calendar_group_slug_required": "O slug do grupo de calendário é obrigatório.",
    "capacity_mandatory": "A capacidade é obrigatória.",
    "capacity_cannot_be_zero": "A capacidade não pode ser zero.",
    "capacity_should_be_a_number": "A capacidade deve ser um número.",
    "capacity_cannot_be_negative": "A capacidade não pode ser negativa.",
    "capacity_should_be_a_whole_number": "A capacidade deve ser um número inteiro.",
    "quantity_mandatory": "Quantidade é obrigatória",
    "quantity_cannot_be_zero": "A quantidade não pode ser zero.",
    "quantity_should_be_a_number": "A quantidade deve ser um número.",
    "quantity_cannot_be_negative": "A quantidade não pode ser negativa.",
    "quantity_should_be_a_whole_number": "A quantidade deve ser um número inteiro.",
    "quantity_cannot_be_less_than_out_of_service_equipments": "A quantidade não pode ser inferior aos equipamentos fora de serviço.",
    "out_of_service_value_should_be_a_number": "O valor fora de serviço deve ser um número.",
    "out_of_service_cannot_be_negative": "Fora de serviço não pode ser negativo",
    "out_of_service_equipments_qty": "O número de equipamentos fora de serviço não pode ser superior à quantidade real de equipamentos.",
    "out_of_service_whole_number": "Fora de serviço deve ser um número inteiro.",
    "slot_duration_required": "A duração do intervalo é obrigatória.",
    "slot_duration_integer": "A duração do slot deve ser um número inteiro.",
    "meeting_duration_validation": "A duração da reunião deve estar entre 1 min e 12 horas",
    "seats_class_required": "Assentos por aula é obrigatório.",
    "seats_class_integer": "Assentos por aula devem ser um número inteiro.",
    "seats_class_validation": "Isso não pode ser maior que 9999 nem menor que 0.",
    "meeting_location_required": "O local da reunião é obrigatório.",
    "meeting_location_empty": "Insira um valor para todos os tipos de localização.",
    "meeting_location_duplicate": "Valor duplicado para o mesmo tipo de localização não é permitido.",
    "meeting_location_booker_multiple": "O recurso Ask the Booker não é permitido para múltiplos membros da equipe."
  },
  "custom_values": {
    "assigned_user": "Usuário atribuído",
    "full_name": "Nome completo",
    "first_name": "Nome",
    "last_name": "Sobrenome",
    "email": "E-mail",
    "phone": "Telefone",
    "twilio_phone": "Telefone Twilio",
    "account": "Conta",
    "name": "Nome",
    "full_address": "Endereço completo",
    "city": "Cidade",
    "state": "Estado",
    "country": "País",
    "postal_code": "Código postal",
    "contact": "Contato",
    "address1": "Endereço 1",
    "timezone": "Fuso horário",
    "user": "Usuário",
    "appointment": "Compromisso",
    "start_date_time": "Data de início e hora",
    "start_date": "Data de início",
    "start_time": "Hora de início",
    "end_date_time": "Data de término e hora",
    "end_date": "Data de término",
    "end_time": "Hora de término",
    "meeting_location": "Localização da reunião"
  },
  "meeting_location_types": {
    "zoom": "Zoom",
    "google_meet": "Google Meet",
    "phone": "Telefone",
    "full_address": "Endereço completo",
    "microsoft_teams": "Microsoft Teams",
    "custom": "Personalizado"
  },
  "duration_units": {
    "minutes": "Minutos",
    "hours": "Horas"
  },
  "widget_styles": {
    "classic": "Clássico",
    "neo": "Neo"
  },
  "feature_labels": {
    "service_menu": "Menu de serviços",
    "rooms": "Salas",
    "equipments": "Equipamentos"
  },
  "lsa": {
    "categories": {
      "accountant": "Contabilidade",
      "acupuncturist": "Acupuntura",
      "air_duct_cleaner": "Limpeza de dutos de ar",
      "alcohol_treatment": "Serviços de tratamento de alcoolismo",
      "animal_shelter": "Serviços de Resgate de Animais",
      "appliance_repair": "Reparo de eletrodomésticos",
      "architect": "Arquitetura",
      "assisted_living": "Serviços de assistência à vida",
      "babysitter": "Babá",
      "bankruptcy_lawyer": "Lei de falências",
      "beauty_school": "Escola de beleza",
      "business_lawyer": "Direito Empresarial",
      "car_repair": "Serviços automotivos",
      "carpenter": "Carpintaria",
      "carpet_cleaning": "Limpeza de Carpetes",
      "child_care": "Serviços de cuidados infantis",
      "chiropractor": "Serviços de Quiropraxia",
      "cleaning_service": "Limpeza residencial",
      "contract_lawyer": "Direito Contratual",
      "countertop_pro": "Serviços de bancadas",
      "criminal_lawyer": "Direito Penal",
      "dance_instructor": "Instrução de dança",
      "disability_lawyer": "Direito das pessoas com deficiência",
      "driving_instructor": "Instrução de direção",
      "dui_lawyer": "Lei sobre condução sob influência de substâncias psicoativas",
      "electrician": "Elétrica",
      "energy_efficiency_pro": "Serviços de Eficiência Energética",
      "estate_lawyer": "Direito imobiliário",
      "event_planner": "Planejamento de Eventos",
      "family_lawyer": "Direito de Família",
      "fencing_pro": "Cercamento",
      "financial_planner": "Planejamento financeiro",
      "first_aid_trainer": "Treinamento de primeiros socorros",
      "flooring_pro": "Pisos",
      "foundation_pro": "Fundamentos",
      "funeral_home": "Serviços Funerários",
      "garage_door_pro": "Porta de Garagem",
      "general_contractor": "Melhorias domésticas",
      "handyman": "Faz-tudo",
      "home_inspector": "Inspeção residencial",
      "home_security": "Serviços de segurança residencial",
      "home_theater": "Serviços de home theater",
      "hvac": "HVAC",
      "immigration_lawyer": "Lei de Imigração",
      "interior_designer": "Estilização de interiores",
      "ip_lawyer": "Direito de Propriedade Intelectual",
      "junk_removal": "Remoção de lixo",
      "labor_lawyer": "Lei trabalhista",
      "landscaper": "Paisagismo",
      "language_instructor": "Instrução de idiomas",
      "lawn_care": "Cuidados com o gramado",
      "litigation_lawyer": "Direito Contencioso",
      "locksmith": "Serralheiro",
      "malpractice_lawyer": "Lei de negligência médica",
      "massage_center": "Serviços de massagem",
      "massage_school": "Escola de massagem",
      "mover": "Movendo",
      "nursing_home": "Serviço de lar de idosos",
      "painter": "Pintura",
      "personal_injury_lawyer": "Lei de lesões corporais",
      "personal_trainer": "Treinamento pessoal",
      "pest_control": "Controle de pragas",
      "pet_adoption": "Serviços de adoção de pets",
      "pet_boarding": "Hospedagem para pets",
      "pet_grooming": "Serviços de tosa para pets",
      "pet_trainer": "Treinamento de pets",
      "photographer": "Fotografia",
      "plumber": "Encanamento",
      "pool_cleaner": "Limpeza de Piscinas",
      "pool_contractor": "Contratação de piscinas",
      "preschool": "Pré-escola",
      "psychologist": "Serviços de Psicologia",
      "real_estate_agent": "Imóveis",
      "real_estate_lawyer": "Direito Imobiliário",
      "rehab": "Serviços de Reabilitação",
      "roofer": "Cobertura",
      "sewage_pro": "Serviços de sistema de esgoto",
      "siding_pro": "Revestimento",
      "smart_home": "Serviços para casas inteligentes",
      "snow_removal": "Serviços de Remoção de Neve",
      "spa": "Serviços de Spa",
      "tax_lawyer": "Direito tributário",
      "tax_specialist": "Serviços fiscais",
      "therapist": "Terapia",
      "towing_pro": "Assistência rodoviária",
      "traffic_lawyer": "Lei de trânsito",
      "tree_service": "Serviços para árvores",
      "tutor": "Tutoria",
      "upholstery_cleaner": "Limpeza de estofados",
      "veterinarian": "Serviços Veterinários",
      "videographer": "Serviços de Vídeo",
      "water_damage": "Serviços de danos causados pela água",
      "weight_loss_service": "Serviços de perda de peso",
      "window_cleaner": "Limpeza de janelas",
      "window_repair": "Serviços de Janelas",
      "windshield_repair_pro": "Vidros automotivos",
      "yoga_instructor": "Ioga"
    },
    "job_types": {
      "accountant_other": "Outro",
      "bankruptcy_tax_litigation": "Litígio de impostos de falência",
      "bookkeeping": "Contabilidade",
      "business_consulting": "Consultoria empresarial",
      "debt_collection_relief": "Alívio de cobrança de dívidas",
      "irs_representation_resolution": "Representação e Resolução do IRS",
      "payroll": "Folha de pagamento",
      "tax_planning_business": "Planejamento tributário empresarial",
      "tax_planning_individual": "Planejamento tributário individual",
      "tax_return_business": "Declaração de Imposto de Renda Empresarial",
      "tax_return_individual": "Declaração de Imposto de Renda Individual",
      "trusts_estates_accounting": "Contabilidade de patrimônios e fundos",
      "acupressure": "Acupressão",
      "acupuncture": "Acupuntura",
      "acupuncturist_other": "Outro",
      "cupping": "Ventosas",
      "gua_sha": "Gua Sha",
      "heat_therapy": "Terapia de calor",
      "herbal_therapy": "Fitoterapia",
      "infrared_therapy": "Terapia Infravermelha",
      "moxibustion": "Moxabustão",
      "qigong": "Qigong",
      "shiatsu": "Shiatsu",
      "tui_na": "Tui Na",
      "air_duct_cleaning": "Limpeza de Dutos de Ar",
      "air_duct_filter_replacement": "Substituição do filtro",
      "air_duct_other": "Outro",
      "dryer_vent_cleaning": "Limpeza de dutos de secadora",
      "furnace_cleaning": "Limpeza de fornos",
      "indoor_air_quality_testing": "Teste de qualidade do ar interno",
      "alcohol_treatment_other": "Outro",
      "animal_shelter_cat_adoption": "Adoção de Gatos",
      "animal_shelter_dog_adoption": "Adoção de cães",
      "animal_shelter_other": "Outro",
      "animal_shelter_other_animal_adoption": "Adoção de outros animais",
      "animal_shelter_other_veterinary_services": "Outros serviços veterinários",
      "animal_shelter_spay_neuter": "Castrar ou esterilizar",
      "animal_shelter_vaccinations": "Vacinas",
      "lost_stray_found_animals": "Animais perdidos, extraviados ou encontrados",
      "pet_license": "Licença para pets",
      "pet_surrender": "Entrega de pets",
      "appliance_other": "Outro",
      "repair_dishwasher": "Reparar máquina de lavar loiça",
      "repair_dryer": "Reparar secadora",
      "repair_freezer": "Conserto de freezer",
      "repair_microwave": "Conserto de micro-ondas",
      "repair_oven": "Reparar forno",
      "repair_refrigerator": "Conserto de refrigerador",
      "repair_refrigerator_freezer": "Conserto de refrigerador/congelador",
      "repair_stove_cooktop": "Reparar fogão/cooktop",
      "repair_stove_cooktop_oven": "Conserto de fogão / cooktop / forno",
      "repair_washer": "Conserto de lavadora",
      "repair_washer_dryer": "Conserto de lavadora/secadora",
      "3d_architectural_rendering": "Renderização Arquitetônica 3D",
      "adaptive_reuse_historical_renovation": "Reutilização adaptativa e restauração histórica",
      "architect_other": "Outro",
      "architectural_designing": "Design arquitetônico",
      "architectural_engineering": "Engenharia arquitetônica",
      "building_code_analysis_permit_coordination": "Análise de código e permissões",
      "consulting": "Consultoria",
      "home_building_improvement": "Construção e melhoria de residências",
      "interior_design_architect": "Estilização de interiores",
      "planning_zoning_approval_assistance": "Aprovação de Planejamento e Zoneamento",
      "project_managing_architect": "Gerenciamento de Projetos",
      "site_master_planning": "Planejamento mestre do local",
      "assisted_living_housekeeping_and_laundry": "Serviços de limpeza e lavanderia",
      "assisted_living_meal_services": "Serviços de refeições",
      "assisted_living_memory_care": "Cuidados com a memória",
      "assisted_living_other": "Outro",
      "assisted_living_rehabilitation_services": "Serviços de Reabilitação",
      "assisted_living_transportation": "Transporte",
      "assisted_living_wellness_programs": "Programas de bem-estar",
      "daily_living_assistance": "Assistência à vida diária",
      "medication_management": "Gestão de medicamentos",
      "short_term_stays": "Estadias de curta duração",
      "social_and_recreational_activities": "Atividades Recreativas",
      "babysitter_other": "Outro",
      "event_babysitting": "Babá para eventos",
      "homework_assistance": "Assistência para tarefas",
      "housekeeping_laundry": "Serviços de limpeza e lavanderia",
      "meal_preparation": "Preparação de Refeições",
      "nanny_services": "Serviços de Babá",
      "overnight_babysitting": "Babá durante a noite",
      "pick_up_and_drop_off": "Retirada e devolução",
      "shopping_errand": "Compras e tarefas",
      "special_needs_care": "Cuidados com necessidades especiais",
      "virtual_babysitting": "Babá virtual",
      "agriculture_bankruptcy": "Falência no setor agrícola",
      "bankruptcy_lawyer_other": "Outro",
      "bankruptcy_litigation": "Litígio de Falência",
      "chapter_11_bankruptcy": "Falência do Capítulo 11",
      "chapter_13_bankruptcy": "Capítulo 13 Falência",
      "chapter_7_bankruptcy": "Falência do Capítulo 7",
      "corporate_bankruptcy": "Falência corporativa",
      "creditor_harassment": "Assédio de Credores",
      "debt_settlement": "Pagamento de dívidas",
      "foreclosure_bankruptcy_lawyer": "Execução hipotecária",
      "personal_bankruptcy": "Falência Pessoal",
      "repossession": "Reintegração de posse",
      "wage_garnishment": "Penhora salarial",
      "beauty_school_barbering": "Barbearia",
      "beauty_school_business_management": "Gestão de empresa",
      "beauty_school_cosmetology": "Cosmetologia",
      "beauty_school_esthetics": "Estética",
      "beauty_school_hair_cutting": "Corte de cabelo",
      "beauty_school_hair_design": "Design de cabelo",
      "beauty_school_makeup": "Maquiagem",
      "beauty_school_massage_therapy": "Massoterapia",
      "beauty_school_nail_technology": "Tecnologia de unhas",
      "beauty_school_other": "Outro",
      "beauty_school_retail_training": "Treinamento em varejo",
      "banking_finance_law": "Bancos e finanças",
      "business_lawyer_other": "Outro",
      "business_licenses_permits": "Licenças e autorizações comerciais",
      "business_litigation": "Litígio empresarial",
      "business_taxes": "Impostos empresariais",
      "business_transactions_business_lawyer": "Transações comerciais",
      "commercial_bankruptcy": "Falência comercial",
      "commercial_contracts_business_lawyer": "Contratos Comerciais",
      "employment_law_business_lawyer": "Direito do Trabalho",
      "incorporation_restructuring": "Incorporação e reestruturação",
      "insurance_law": "Lei de seguros",
      "intellectual_property_law": "Direito de Propriedade Intelectual",
      "mergers_acquisitions_business_lawyer": "Fusões e Aquisições",
      "partnership_agreements_business_lawyer": "Acordos de Parceria",
      "patents_copyrights_trademarks": "Patentes, direitos autorais e marcas registradas",
      "securities_law": "Lei de Valores Mobiliários",
      "shareholder_disputes": "Disputas entre acionistas",
      "air_and_cabin_filter": "Filtro de ar e cabine",
      "battery": "Bateria",
      "body_and_trim": "Corpo e aparar",
      "brakes": "Freios",
      "car_air_conditioning": "Ar Condicionado",
      "car_electrical": "Elétrica",
      "car_repair_other": "Outro",
      "check_engine_light_diagnostic": "Diagnóstico da luz de verificação do motor",
      "exhaust": "Escapamento",
      "oil_change": "Troca de óleo",
      "steering_suspension": "Direção/Suspensão",
      "tires": "Pneus",
      "transmission": "Transmissão",
      "cabinetry": "Marcenaria",
      "carpenter_other": "Outro",
      "decking": "Deques",
      "drywalling": "Drywall",
      "fencing": "Cercamento",
      "general_installations": "Instalações Gerais",
      "general_repairs_maintenance": "Reparos Gerais e Manutenção",
      "remodeling": "Reforma",
      "shelving_storage": "Estantes e armazenamento",
      "carpet_cleaning_other": "Outro",
      "clean_area_rugs": "Limpeza de tapetes",
      "clean_carpet": "Limpar Carpete",
      "clean_drapes_and_curtains": "Limpeza de cortinas e persianas",
      "clean_upholstery": "Limpeza de estofados",
      "remove_pet_stains_and_odors": "Remover machas e odores de pets",
      "after_school_care": "Cuidados pós-escolares",
      "all_hours_daycare": "Creche 24 horas",
      "bilingual_daycare": "Creche Bilíngue",
      "child_care_other": "Outro",
      "drop_in_daycare": "Creche sem hora marcada",
      "full_time_daycare": "Creche em período integral",
      "in_home_daycare": "Creche domiciliar",
      "infant_programs": "Programas para bebês",
      "part_time_daycare": "Creche de meio período",
      "pre_kindergarten_programs": "Programas de pré-escola",
      "preschool_programs": "Programas pré-escolares",
      "school_age_programs": "Programas para crianças em idade escolar",
      "special_needs_daycare": "Creche para necessidades especiais",
      "summer_daycare": "Creche de verão",
      "toddler_programs": "Programas para bebês",
      "weekend_daycare": "Grade de final de semana",
      "chiropractor_acupuncture": "Acupuntura",
      "chiropractor_chiropractic": "Quiropraxia",
      "chiropractor_massage_therapy": "Terapia de Massagem",
      "chiropractor_other": "Outro",
      "diagnosis": "Diagnóstico",
      "eastern_medicine": "Medicina Oriental",
      "exercise_counseling": "Aconselhamento sobre exercícios",
      "pain_management": "Gerenciamento da dor",
      "physical_therapy": "Fisioterapia",
      "spinal_adjustments": "Ajustes da coluna",
      "sports_medicine": "Medicina Esportiva",
      "cleaner_other": "Outro",
      "deep_clean": "Limpeza Profunda",
      "moving_clean": "Limpeza de mudanças",
      "office_clean": "Limpeza de Escritório",
      "standard_clean": "Limpeza padrão",
      "assignment_of_contract": "Cessão de contrato",
      "business_transactions_contract_lawyer": "Transações comerciais",
      "commercial_contracts_contract_lawyer": "Contratos comerciais",
      "contract_dispute": "Disputa contratual",
      "contract_lawyer_other": "Outro",
      "contract_negotiation": "Negociação de acordos",
      "contract_review": "Revisão de contrato",
      "employment_contracts_contract_lawyer": "Contratos de trabalho",
      "franchise_agreements": "Contratos de franquia",
      "mergers_acquisitions_contract_lawyer": "Fusões e aquisições",
      "non_disclosure_agreements_contract_lawyer": "Acordos de Confidencialidade",
      "partnership_agreements_contract_lawyer": "Acordos de Parceria",
      "power_of_attorney_contract_lawyer": "Procuração",
      "security_agreements": "Acordos de segurança",
      "warranties": "Garantias",
      "bathroom_countertops": "Bancadas de banheiro",
      "bathroom_wall_panels": "Painéis de Parede para Banheiro",
      "countertop_design": "Design da banca",
      "countertop_installation": "Instalação de Bancada",
      "countertop_pro_other": "Outro",
      "fireplace_facade": "Fachada de lareira",
      "granite_countertops": "Bancadas de granito",
      "kitchen_countertops": "Bancadas de cozinha",
      "kitchen_wall_panels": "Painéis de parede para cozinha",
      "laminate_countertops": "Bancadas de Laminado",
      "marble_countertops": "Bancadas de mármore",
      "quartz_countertops": "Bancadas de Quartzo",
      "remodeling_countertop_pro": "Reforma",
      "repair_maintenance_countertop_pro": "Reparo e Manutenção",
      "stone_slab_countertops": "Bancadas de pedra",
      "tile_countertops": "Bancadas de azulejos",
      "corporate_representation": "Representação Corporativa",
      "criminal_immigration_defense": "Defesa criminal em imigração",
      "criminal_lawyer_other": "Outro",
      "domestic_violence": "Violência doméstica",
      "drug_possession": "Posse de drogas",
      "duis_reckless_driving": "Condução sob a influência de substâncias psicoativas e condução imprudente",
      "expungement": "Expurgo",
      "federal_crimes": "Crimes Federais",
      "felonies": "Delitos",
      "petty_crimes_misdemeanors": "Crimes e contravenções de pets",
      "restraining_orders": "Ordens de restrição",
      "sex_offenses": "Crimes sexuais",
      "three_strikes_law": "Lei das três infrações",
      "dance_instructor_african": "Africano",
      "dance_instructor_ballet": "Balé",
      "dance_instructor_ballroom": "Salão de Baile",
      "dance_instructor_belly": "Barriga",
      "dance_instructor_bollywood": "Bollywood",
      "dance_instructor_contemporary": "Contemporâneo",
      "dance_instructor_folk_traditional": "Folk e tradicional",
      "dance_instructor_hip_hop": "Hip Hop",
      "dance_instructor_jazz": "Jazz",
      "dance_instructor_kids_classes": "Aulas para crianças",
      "dance_instructor_latin": "Latim",
      "dance_instructor_modern": "Moderno",
      "dance_instructor_other": "Outro",
      "dance_instructor_tap": "Toque",
      "dance_instructor_wedding": "Casamento",
      "disability_hearings": "Audiências sobre deficiência",
      "disability_lawyer_other": "Outro",
      "long_term_disability": "Incapacidade de longo prazo",
      "short_term_disability": "Incapacidade temporária",
      "social_security_disability_insurance": "Seguro de invalidez da previdência social",
      "ssa_claim_reconsideration": "Reconsideração de pedido de indenização da SSA",
      "ssa_disability_appeals": "Apelações de deficiência da SSA",
      "ssa_disability_applications": "Solicitações de benefício por incapacidade da SSA",
      "ssa_disability_benefits": "Benefícios por incapacidade da SSA",
      "ssa_family_benefits": "Benefícios familiares da SSA",
      "ssa_impairment_listings": "Listagens de deficiências da SSA",
      "supplemental_security_income": "Renda de segurança suplementar",
      "veterans_disability_benefits": "Benefícios por incapacidade para veteranos",
      "workers_compensation_disability_lawyer": "Remuneração dos trabalhadores",
      "behind_the_wheel_lessons": "Aulas Práticas de Direção",
      "commercial_license_training": "Treinamento de licença comercial",
      "defensive_driving_lessons": "Aulas de direção defensiva",
      "drivers_education_classes": "Aulas de educação para motoristas",
      "driving_instructor_other": "Outro",
      "manual_transmission_lessons": "Aulas de transmissão manual",
      "motorcycle_lessons": "Aulas de motocicleta",
      "traffic_school": "Escola de trânsito",
      "dui_dwi_dui_lawyer": "Condução sob a influência de substâncias psicoativas",
      "dui_injuries_dui_lawyer": "Condução sob a influência de substâncias psicoativas com lesão",
      "dui_lawyer_other": "Outro",
      "dui_with_accident": "Condução sob a influência de substâncias psicoativas com acidente",
      "felony_dui": "Crime grave de condução sob a influência de substâncias psicoativas",
      "invalid_tests": "Testes Inválidos",
      "multiple_offenses": "Ofensas múltiplas",
      "reckless_driving_dui_lawyer": "Direção Imprudente",
      "underage_dui": "Menores de idade conduzindo sob a influência de substâncias psicoativas",
      "electric_car_charger": "Instalar carregador de carro elétrico",
      "electrician_other": "Outro",
      "electrician_remodeling": "Reforma",
      "install_fan": "Instalar ventilador",
      "install_ground_wire": "Instalar fio terra",
      "install_light_fixtures": "Instalar luminárias",
      "install_outdoor_lighting": "Instalar iluminação externa",
      "install_outlets_switches": "Instalar tomadas ou interruptores",
      "install_security_system": "Instalar sistema de segurança",
      "relocate_outlets_switches": "Realocar tomadas ou interruptores",
      "repair_fan": "Reparar ventilador",
      "repair_light_fixtures": "Reparar luminárias",
      "repair_outlets_switches": "Conserto de tomadas ou interruptores",
      "repair_panel": "Reparar painel",
      "replace_upgrade_panel": "Substituir ou atualizar painel",
      "restore_power": "Restaurar energia",
      "energy_efficiency_pro_other": "Outro",
      "charitable_giving": "Doações",
      "contests_litigation": "Concursos / Litígios",
      "deeds": "Escrituras",
      "estate_lawyer_other": "Outro",
      "estate_planning_lawyer": "Planejamento patrimonial",
      "guardianship_estate_lawyer": "Tutela",
      "medical_power_of_attorney": "Procuração médica",
      "power_of_attorney_estate_lawyer": "Procuração",
      "probate_estate_lawyer": "Advogado de sucessões",
      "trusts": "Créditos",
      "wills": "Testamentos",
      "anniversary_planner": "Aniversário",
      "baby_shower_planner": "Chá de bebê",
      "bar_and_bat_mitzvah_planner": "Bar e Bat Mitsvá",
      "birthday_party": "Festa de aniversário",
      "children_party": "Festa Infantil",
      "corporate_and_conference_planner": "Corporativo e conferência",
      "event_planner_other": "Outro",
      "quinceanera_planner": "Quinceanera",
      "religious_event": "Evento Religioso",
      "retirement_party": "Festa de Aposentadoria",
      "school_event": "Evento Escolar",
      "theme_party": "Festa temática",
      "wedding_and_engagement_planner": "Casamento e noivado",
      "adoption": "Adoção",
      "child_support": "Pensão alimentícia",
      "contested_divorce": "Divórcio contestado",
      "debt_division": "Divisão de Dívida",
      "family_lawyer_other": "Outro",
      "guardianship_family_lawyer": "Tutela",
      "mediation_family_lawyer": "Mediação",
      "modifications_of_orders": "Modificação de pedidos",
      "parent_timesharing": "Compartilhamento de tempo dos pais",
      "paternity": "Paternidade",
      "prenuptial_postnuptial_agreements": "Acordos pré-nupciais e matrimoniais",
      "probate_family_lawyer": "Homologação",
      "property_divisions": "Divisão de propriedade",
      "protective_orders_domestic_violence_issues": "Ordens de Restrição",
      "spousal_support_alimony": "Pensão alimentícia entre cônjuges e pensão alimentícia",
      "uncontested_divorce": "Divórcio consensual",
      "custom_construction": "Construção personalizada",
      "fence_design": "Design de cerca",
      "fencing_other": "Outro",
      "installation_fencing_pro": "Instalação de Cercas",
      "repairs_maintenance_fencing_pro": "Reparos e Manutenção",
      "education_savings": "Poupança para educação",
      "estate_financial_planning": "Planejamento patrimonial",
      "financial_planning": "Planejamento financeiro",
      "financial_planning_other": "Outro",
      "home_purchase": "Compra de casa",
      "insurance": "Seguro",
      "investment_advising": "Consultoria de investimentos",
      "retirement_savings": "Aposentadoria",
      "tax_planning": "Planejamento tributário",
      "advanced_cardiac_life_support": "Suporte avançado de vida cardíaca",
      "aed_defibrillator": "DEA - Desfibrilador",
      "basic_life_support": "Suporte básico de vida",
      "cpr": "RCP",
      "first_aid": "Primeiros Socorros",
      "first_aid_trainer_other": "Outro",
      "pediatric_advanced_life_support": "Suporte avançado de vida em pediatria",
      "pediatric_cpr_first_aid": "RCP Pediátrica e Primeiros Socorros",
      "pet_cpr_first_aid": "RCP e primeiros socorros para pets",
      "wilderness_first_aid": "Primeiros socorros em ambientes selvagens",
      "baseboards": "Rodapés",
      "carpet": "Carpete",
      "flooring_other": "Outro",
      "hardwood": "Madeira de lei",
      "installation_flooring_pro": "Instalação de pisos",
      "marble": "Mármore",
      "polishing": "Polimento de Piso",
      "refinishing": "Restauração de pisos",
      "repair_maintenance_flooring_pro": "Reparo e manutenção de pisos",
      "stair_flooring": "Piso de escada",
      "tile": "Ladrilho",
      "wood_floor_sanding": "Lixamento de Piso de Madeira",
      "basement_waterproofing": "Impermeabilização de porão",
      "crawl_spaces": "Fundações do espaço subterrâneo",
      "foundation_drainage": "Drenagem de Fundação",
      "foundation_installation": "Instalação da fundação",
      "foundation_pro_other": "Outro",
      "foundation_raising": "Aumento da fundação",
      "repairs_maintenance_foundation_pro": "Reparos e Manutenção",
      "slab_foundation": "Fundação de laje",
      "steel_pier_pilings": "Estacas de aço para pilares",
      "water_moisture_control": "Controle de água e umidade",
      "burials": "Sepultamentos",
      "caskets": "Caixões",
      "cremation": "Cremação",
      "funeral_home_flowers": "Flores",
      "funeral_home_other": "Outro",
      "funeral_home_transportation_transfers": "Transporte e transferências",
      "funeral_home_veteran_services": "Serviços para Veteranos",
      "funerals": "Funerais",
      "gravestones": "Lápides",
      "grief_services": "Serviços de assistência ao luto",
      "memorials": "Registros históricos",
      "urns": "Urnas",
      "garage_door_other": "Outro",
      "general_maintenance": "Manutenção geral",
      "install_garage_door": "Instalar porta de garagem",
      "install_opener": "Instalar mecanismo de abertura",
      "repair_cables": "Reparar Cabos",
      "repair_garage_door": "Reparar porta de garagem",
      "repair_gate": "Reparar portão",
      "repair_rollers_tracks": "Conserto de rolos e trilhos",
      "replace_door_panels": "Substituir painéis de porta",
      "replace_opener": "Substituir abertura",
      "replace_springs": "Substituir molas",
      "accessory_buildings": "Edificações acessórias",
      "bathroom_remodel": "Remodelação de banheiros",
      "decks_patio": "Decks e pátios",
      "exterior_finishing": "Acabamento Externo",
      "foundations_concrete": "Fundações e Concreto",
      "general_contractor_commercial_projects": "Projetos comerciais",
      "general_contractor_other": "Outro",
      "home_addition": "Ampliação de casas",
      "home_building": "Construção de casas",
      "home_remodel_renovation": "Remodelação e renovação de casas",
      "interior_finishing": "Acabamento Interno",
      "kitchen_remodel": "Reforma de cozinhas",
      "roofing": "Cobertura",
      "assemble_furniture": "Montar Móveis",
      "clean_gutters": "Limpeza de calhas",
      "handyman_other": "Outro",
      "install_drywall": "Instalar drywall",
      "install_flooring": "Instalar piso",
      "install_tile": "Instalação de ladrilhos",
      "install_water_fixtures": "Instalar acessórios hidráulicos",
      "mount_tv": "Montar TV",
      "paint_indoors": "Pintar ambientes internos",
      "paint_outdoors": "Pinte ao ar livre",
      "repair_drywall": "Reparar Drywall",
      "repair_flooring": "Reparo de pisos",
      "repair_water_fixtures": "Reparar acessórios hidráulicos",
      "replace_tile": "Substituir azulejo",
      "buyer_seller_inspection": "Inspeção de comprador e vendedor",
      "commercial_properties": "Propriedades Comerciais",
      "fire_safety": "Segurança contra incêndios",
      "fireplace_chimney": "Lareira e chaminé",
      "full_home_inspection": "Inspeção residencial completa",
      "home_inspector_electrical": "Elétrica",
      "home_inspector_foundation": "Fundamentos",
      "home_inspector_hvac": "HVAC",
      "home_inspector_mold": "Mofo",
      "home_inspector_new_construction": "Nova construção",
      "home_inspector_other": "Outro",
      "home_inspector_plumbing": "Encanamento",
      "home_inspector_roof": "Telhado",
      "home_inspector_structural": "Estrutural",
      "home_warranty": "Garantia residencial",
      "water_testing": "Teste de Água",
      "well_or_septic_system": "Poço ou sistema séptico",
      "wood_insects": "Madeira e Insetos",
      "access_control": "Controle de acesso",
      "alarm_systems": "Sistemas de Alarme",
      "commercial_security_systems": "Sistemas de segurança comercial",
      "fire_smoke_detection": "Detecção de incêndio e fumaça",
      "home_security_doors": "Portas",
      "home_security_locks": "Fechaduras",
      "home_security_other": "Outro",
      "home_security_windows": "Janelas",
      "monitoring_services": "Serviços de monitoramento",
      "residential_security_systems": "Sistemas de segurança residencial",
      "smart_home_integration": "Integração de casa inteligente",
      "video_surveillance": "Vigilância por vídeo",
      "audio_video_installation": "Instalação de áudio e vídeo",
      "commercial_projects": "Projetos comerciais",
      "home_theater_design": "Design de home theater",
      "home_theater_lighting": "Iluminação",
      "home_theater_other": "Outro",
      "home_theater_smart_home_integration": "Integração de casa inteligente",
      "install_tv": "Instalar TV",
      "network_it_services": "Serviços de rede e TI",
      "outdoor_installations": "Instalações ao ar livre",
      "soundproofing": "Isolamento Acústico",
      "whole_house_audio_video": "Áudio e vídeo para toda a casa",
      "ac_maintenance": "Manutenção de AC",
      "clean_ducts_vents": "Limpar dutos e aberturas",
      "ductless_heating_and_ac_services": "Serviços de aquecimento e ar condicionado sem dutos",
      "heating_maintenance": "Manutenção de aquecimento",
      "hvac_maintenance": "Manutenção de HVAC",
      "hvac_other": "Outro",
      "install_ac": "Instalar AC",
      "install_ducts_vents": "Instalar dutos e ventiladores",
      "install_heating_system": "Instalar sistema de aquecimento",
      "install_thermostat": "Instalar termostato",
      "repair_ac": "Conserto de ar condicionado",
      "repair_ducts_vents": "Conserto de dutos e ventilação",
      "repair_heating_system": "Conserto do sistema de aquecimento",
      "repair_hvac": "Conserto do sistema de climatização",
      "repair_thermostat": "Conserto de termostato",
      "asylum": "Asilo",
      "citizenship": "Cidadania",
      "deportation": "Deportação",
      "family_based_immigration": "Imigração familiar",
      "green_card": "Green Card",
      "immigration_lawyer_other": "Outro",
      "investment_visa": "Visto de investimento",
      "outbound_work_permits": "Permissões de trabalho enviadas",
      "student_visa": "Visto de estudante",
      "visitor_visa": "Visto de visitante",
      "work_visa": "Visto de Trabalho",
      "appliance_selection": "Seleção de eletrodomésticos",
      "cabinetry_molding_hardware_design": "Design de armários e ferragens",
      "decorating": "Decorando",
      "door_design": "Design de portas",
      "exterior_building_design": "Design de edifícios exteriores",
      "flooring_selection": "Seleção de Pisos",
      "interior_designer_other": "Outro",
      "landscaping_design": "Design de paisagismo",
      "lighting_design": "Design de iluminação",
      "multifamily_housing_design": "Design de habitação multifamiliar",
      "room_planning": "Planejamento de salas",
      "stone_brick_stucco_design": "Design de pedra, tijolo e estuque",
      "window_design": "Design de janelas",
      "advertisements": "Anúncios",
      "copyright": "Direitos autorais",
      "export_control": "Controle de exportação",
      "franchises": "Franquias",
      "international_ip": "IP Internacional",
      "ip_lawyer_other": "Outro",
      "ip_strategy": "Estratégia de propriedade intelectual",
      "ip_transactions": "Transações de propriedade intelectual",
      "licensing": "Licenciamento",
      "litigation_ip_lawyer": "Litígio",
      "non_disclosure_agreements_ip_lawyer": "Acordos de confidencialidade",
      "patents": "Patentes",
      "technology_transfer": "Transferência de tecnologia",
      "trade_secrets": "Segredos Comerciais",
      "trademarks": "Marcas registradas",
      "appliance_removal": "Remoção de eletrodomésticos",
      "construction_waste_removal": "Remoção de Resíduos de Construção",
      "donation_pickup": "Coleta de Doações",
      "electronic_waste_removal": "Remoção de resíduos eletrônicos",
      "furniture_removal": "Remoção de móveis",
      "general_junk_removal": "Remoção geral de entulho",
      "hazardous_waste_removal": "Remoção de Resíduos Perigosos",
      "house_garage_cleanout": "Limpeza de casa/garagem",
      "junk_removal_other": "Outro",
      "yard_waste_removal": "Remoção de resíduos de jardinagem",
      "employment_contracts_labor_lawyer": "Contratos de trabalho",
      "employment_law_labor_lawyer": "Direito do Trabalho",
      "exempt_employee_status": "Status de funcionário isento",
      "labor_law": "Lei trabalhista",
      "labor_lawyer_other": "Outro",
      "labor_negotiations": "Negociações trabalhistas",
      "privacy_rights": "Direitos de privacidade",
      "sexual_harassment": "Assédio Sexual",
      "unpaid_overtime": "Horas extras não pagas",
      "whistle_blowing": "Denúncia de Irregularidades",
      "workers_compensation_labor_lawyer": "Remuneração dos trabalhadores",
      "wrongful_termination": "Rescisão injusta",
      "artificial_turf_installation": "Instalação de grama sintética",
      "concrete_masonry": "Disposição irregular de concreto",
      "driveway_landscaping": "Paisagismo de entrada de automóveis",
      "garden_decorations": "Decorações de jardim",
      "grading_resloping": "Nivelamento e reclinação",
      "hardscapes": "Paisagismo",
      "landscape_design": "Design de paisagem",
      "landscape_installations": "Instalações paisagísticas",
      "landscaper_other": "Outro",
      "outdoor_steps": "Degraus Externos",
      "outdoor_water_feature": "Recursos hídricos externos",
      "paving_driveway_walkway": "Pavimentação de calçadas ou passarelas",
      "retaining_walls": "Muros de contenção",
      "sidewalk_walkway_landscaping": "Paisagismo de passarelas",
      "sod_seeding": "Grama e semeadura",
      "stone_masonry": "Disposição irregular de pedra",
      "arabic": "Árabe",
      "english": "English",
      "french": "French",
      "german": "German",
      "hebrew": "Hebraico",
      "italian": "Italian",
      "japanese": "Japanese",
      "korean": "Korean",
      "language_instructor_other": "Outro",
      "mandarin": "Mandarim",
      "portuguese": "Português",
      "russian": "Russian",
      "sign_language": "Língua de sinais",
      "spanish": "Spanish",
      "irrigation_system_repair_maintenance": "Reparo/Manutenção de Sistema de Irrigação",
      "lawn_care_other": "Outro",
      "lawn_mowing_maintenance": "Corte de grama / manutenção",
      "lawn_pest_control": "Controle de pragas em gramados",
      "mulching": "Cobertura morta",
      "seeding": "Semeadura",
      "sod_installation": "Instalação de Grama",
      "weed_control": "Controle de ervas daninhas",
      "yard_cleanup": "Limpeza de quintal",
      "appeals": "Apelações",
      "case_assessment_litigation_lawyer": "Avaliação de caso",
      "civil_litigation": "Litígio Civil",
      "commercial_litigation": "Litígio Comercial",
      "contracts_and_agreements": "Contratos e Acordos",
      "criminal_litigation": "Litígio criminal",
      "litigation_lawyer_other": "Outro",
      "mediation_litigation_lawyer": "Mediação",
      "settlements": "Pagamentos",
      "building_lockout": "Bloqueio de construção",
      "copy_building_key": "Copiar chaves de construção",
      "copy_vehicle_key": "Copiar chave de veículo",
      "install_hardware": "Instalar equipamentos",
      "locksmith_other": "Outro",
      "new_key_fob": "Novo chaveiro",
      "rekey_lock": "Reconfigurar fechadura",
      "repair_hardware": "Reparar hardware",
      "vehicle_lockout": "Desbloqueio de veículos",
      "consent_issues": "Problemas de consentimento",
      "diagnosis_errors": "Erros de diagnóstico",
      "malpractice_lawyer_other": "Outro",
      "medical_negligence": "Negligência Médica",
      "treatment_errors": "Erros de Tratamento",
      "massage_center_other": "Outro",
      "massage_school_advanced_neuromuscular_therapy": "Terapia Neuromuscular Avançada",
      "massage_school_business_and_ethics": "Negócios e ética",
      "massage_school_clinical_therapies": "Terapias clínicas",
      "massage_school_continuing_education": "Educação continuada",
      "massage_school_deep_tissue_massage": "Massagem de tecidos profundos",
      "massage_school_energetics": "Energética",
      "massage_school_hydrotherapy": "Hidroterapia",
      "massage_school_lymphatic_massage": "Massagem Linfática",
      "massage_school_online_massage_therapy": "Terapia de massagem on-line",
      "massage_school_other": "Outro",
      "massage_school_prenatal_massage": "Massagem Pré-natal",
      "massage_school_sports_massage": "Massagem Esportiva",
      "massage_school_student_massage_clinic": "Clínica de massagem para estudantes",
      "massage_school_swedish_massage": "Massagem sueca",
      "massage_theory": "Teoria da Massagem",
      "massage_therapy_training": "Treinamento em massoterapia",
      "in_state_move": "Mudança dentro do estado",
      "local_move": "Mudança local",
      "mover_other": "Outro",
      "moving_junk_removal": "Remoção de lixo",
      "moving_storage": "Armazenamento",
      "out_of_state_move": "Mudança para fora do estado",
      "oversized_item_move": "Mover item de grandes dimensões",
      "packing_unpacking": "Empacotamento / Desempacotamento",
      "senior_move": "Mudança de idoso",
      "vehicle_transport": "Transporte de Veículos",
      "cardiac_care": "Cuidados Cardíacos",
      "general_medical_care": "Cuidados Médicos Gerais",
      "hospice": "Hospício",
      "iv_therapy": "Terapia IV",
      "nursing_home_meal_services": "Serviços de refeição",
      "nursing_home_memory_care": "Cuidados com a Memória",
      "nursing_home_other": "Outro",
      "nursing_home_pain_management": "Gerenciamento da dor",
      "nursing_home_rehabilitation_services": "Serviços de Reabilitação",
      "nursing_home_wellness_programs": "Programas de bem-estar",
      "outpatient_rehabilitation": "Reabilitação Ambulatorial",
      "post_hospital_care": "Cuidados pós-hospitalares",
      "respiratory_and_pulmonary_care": "Cuidados Respiratórios e Pulmonares",
      "senior_activity_programs": "Programas de atividades para idosos",
      "short_term_rehabilitation": "Reabilitação de curto prazo",
      "wound_care": "Tratamento de feridas",
      "exterior_painting": "Pintura Externa",
      "interior_painting": "Pintura Interna",
      "paint_cabinets": "Pintar armários",
      "paint_doors": "Pintar Portas",
      "painter_other": "Outro",
      "repair_water_damage": "Reparo de danos causados pela água",
      "staining": "Coloração",
      "assault_battery": "Agressão & Lesão Corporal",
      "auto_accidents": "Acidentes de carro",
      "bicycle_accidents": "Acidentes de bicicleta",
      "catastrophic_injuries": "Lesões catastróficas",
      "dog_bites": "Mordidas de cães",
      "dui_injuries_personal_injury_lawyer": "Lesões causadas por dirigir sob a influência de substâncias psicoativas",
      "medical_malpractice": "Negligência médica",
      "motorcycle_accidents": "Acidentes de moto",
      "pain_suffering": "Dor e sofrimento",
      "pedestrian_accidents": "Acidentes com pedestres",
      "personal_injury_lawyer_other": "Outro",
      "product_liability": "Responsabilidade pelo produto",
      "slip_fall": "Escorregar e cair",
      "uninsured_motorist_claims": "Reivindicações de seguro para motoristas",
      "workers_compensation_personal_injury_lawyer": "Remuneração dos trabalhadores",
      "wrongful_death": "Morte por negligência",
      "aerobics": "Aeróbica",
      "athletic_performance": "Desempenho atlético",
      "circuit_training": "Treinamento em circuito",
      "endurance": "Resistência",
      "fitness_assessment": "Avaliação de aptidão física",
      "hiit": "HIIT",
      "nutritional_counseling": "Aconselhamento nutricional",
      "personal_trainer_other": "Outro",
      "strength_conditioning": "Força e Condicionamento",
      "weight_loss": "Perda de Peso",
      "yoga": "Ioga",
      "ants": "Formigas",
      "bed_bugs": "Percevejos",
      "bees": "Abelhas",
      "cockroaches": "Baratas",
      "fleas_or_mites": "Pulgas ou Ácaros",
      "hornets_or_wasps": "Vespas ou marimbondos",
      "mosquitoes": "Mosquitos",
      "pest_control_other": "Outro",
      "pest_inspection": "Inspeção",
      "rodents": "Roedores",
      "spiders": "Aranhas",
      "termites": "Cupins",
      "wildlife": "Vida selvagem",
      "pet_adoption_birds": "Aves",
      "pet_adoption_cats": "Gatos",
      "pet_adoption_dogs": "Cães",
      "pet_adoption_farm_animals": "Animais de fazenda",
      "pet_adoption_fish": "Peixe",
      "pet_adoption_other": "Outro",
      "pet_adoption_reptiles": "Répteis",
      "pet_adoption_small_mammals": "Pequenos mamíferos",
      "pet_adoption_special_needs_animals": "Animais com necessidades especiais",
      "cat_boarding": "Hospedagem para gatos",
      "cat_grooming": "Tosa para gatos",
      "cat_sitting_in_home": "Serviço de cat sitter em casa",
      "dog_boarding": "Hospedagem para cães",
      "dog_boarding_with_training": "Hospedagem de cães com cursos",
      "dog_daycare": "Creche para cães",
      "dog_grooming": "Tosa para cães",
      "dog_sitting_in_home": "Cuidado de cães (em domicílio)",
      "dog_training": "Treinamento de cães",
      "dog_walking": "Passeio com cães",
      "other_pet_boarding": "Outros serviços de hospedagem para pets",
      "other_pet_daycare": "Outros serviços de creche para pets",
      "other_pet_grooming": "Outros serviços de tosa para pets",
      "other_pet_sitting_in_home": "Serviço de pet sitter em casa",
      "pet_boarding_other": "Outro",
      "cat_bathing": "Banho para gatos",
      "cat_ear_cleaning": "Limpeza de orelhas de gato",
      "cat_grooming_and_styling": "Tosa e estilização para gatos",
      "cat_nail_trimming": "Corte de unhas de gatos",
      "dog_anal_gland_expression": "Expressão da glândula anal do cão",
      "dog_bathing_and_blow_dry": "Banho e secagem de cães",
      "dog_ear_cleaning": "Limpeza de orelhas de cachorro",
      "dog_flea_and_tick_treatment": "Tratamento contra pulgas e carrapatos em cães",
      "dog_full_service_grooming": "Serviço completo de tosa para cães",
      "dog_grooming_and_styling": "Tosa e estilização para cães",
      "dog_nail_trimming": "Corte de unhas de cachorro",
      "dog_teeth_brushing": "Limpeza dentária para cães",
      "pet_grooming_other": "Outro",
      "aggressive_dog_training": "Treinamento de cães agressivos",
      "behavior_modification": "Modificação de Comportamento",
      "obedience_training": "Treinamento de obediência",
      "offleash_training": "Treinamento sem coleira",
      "pet_trainer_other": "Outro",
      "puppy_training": "Treinamento de filhotes",
      "service_animal_training": "Cursos de animais de serviço",
      "sport_trick_training": "Treinamento esportivo ou de truques",
      "training_other_animals": "Treinamento para outros animais",
      "corporate_photo": "Corporativo",
      "events_and_parties_photo": "Eventos e festas",
      "family_and_group_photo": "Família e Grupo",
      "headshots_and_portraits": "Fotos de rosto e retratos",
      "individual_photo": "Individual",
      "maternity_and_newborn_photo": "Maternidade e recém-nascido",
      "photographer_other": "Outro",
      "product_photo": "Produto",
      "real_estate_photo": "Imóveis",
      "school_portraits": "Retratos escolares",
      "wedding_and_engagement_photo": "Casamento e Noivado",
      "find_leak": "Encontrar e reparar vazamentos",
      "install_faucet": "Instalar torneira",
      "install_garbage_disposal": "Instalar triturador de lixo",
      "install_shower": "Instalar chuveiro",
      "install_toilet": "Instalar vaso sanitário",
      "install_water_heater": "Instalar aquecedor de água",
      "plumbing_other": "Outro",
      "repair_faucet": "Reparar torneira",
      "repair_garbage_disposal": "Conserto de triturador de lixo",
      "repair_outdoor_systems": "Conserto de sistemas externos",
      "repair_pipe": "Reparar tubulação",
      "repair_sewer": "Reparar esgoto",
      "repair_shower": "Reparar chuveiro",
      "repair_toilet": "Reparar vaso sanitário",
      "repair_water_heater": "Reparar aquecedor de água",
      "unclog_drain": "Desentupir ralo",
      "commercial_pool_cleaning_maintenance": "Limpeza e manutenção de piscinas comerciais",
      "equipment_maintenance_repair": "Reparo e manutenção de equipamentos",
      "one_time_pool_cleaning": "Limpeza única da piscina",
      "ongoing_pool_cleaning": "Limpeza contínua da piscina",
      "pool_cleaner_other": "Outro",
      "pool_cleaner_water_features": "Recursos hídricos",
      "seasonal_opening_closing": "Abertura e fechamento sazonais",
      "spa_hot_tub_cleaning": "Limpeza de Spa e Banheira de Hidromassagem",
      "spa_hot_tub_repairs": "Conserto de spas e banheiras de hidromassagem",
      "tile_pool_wall_cleaning": "Limpeza de azulejos e paredes de piscina",
      "water_testing_balancing": "Teste e balanceamento de água",
      "jetted_lap_pools": "Piscinas de Raia com Jatos",
      "pool_construction": "Construção de Piscinas",
      "pool_contractor_commercial_projects": "Projetos comerciais",
      "pool_contractor_custom_designs": "Designs personalizados",
      "pool_contractor_other": "Outro",
      "pool_contractor_renovation": "Reforma",
      "pool_contractor_repair_cracks": "Reparo de rachaduras",
      "pool_contractor_repair_tile": "Reparar azulejos",
      "pool_contractor_resurfacing": "Repavimentação",
      "pool_contractor_water_features": "Recursos hídricos",
      "pool_hot_tub_equipment": "Equipamento de piscina e banheira de hidromassagem",
      "spa_hot_tub_installation": "Instalação de Spa e Banheira de Hidromassagem",
      "bilingual_programs": "Programas Bilíngues",
      "early_preschool": "Pré-escola precoce",
      "full_day_preschool": "Pré-escola em tempo integral",
      "half_day_preschool": "Pré-escola de meio período",
      "kindergarten_classes": "Aulas de jardim de infância",
      "montessori_programs": "Programas Montessori",
      "play_based_preschool": "Pré-escola baseada em brincadeiras",
      "preschool_infant_programs": "Programas para bebês",
      "preschool_other": "Outro",
      "reggio_emilia_preschool": "Pré-escola Reggio Emilia",
      "special_needs_programs": "Programas especiais",
      "summer_camp": "Acampamento de Verão",
      "waldorf_preschool": "Pré-escola Waldorf",
      "psychologist_other": "Outro",
      "buyer_agent": "Agente do Comprador",
      "first_time_home_buyer": "Comprador de casa pela primeira vez",
      "foreclosed_properties": "Propriedades retomadas",
      "luxury_properties": "Propriedades de luxo",
      "new_construction": "Nova construção",
      "property_management": "Gestão de propriedades",
      "real_estate_agent_other": "Outro",
      "relocation": "Realocação",
      "rentals": "Aluguéis",
      "sellers_agent": "Agente do vendedor",
      "commercial_real_estate": "Imóveis comerciais",
      "easements": "Servidões",
      "encroachment": "Invasão",
      "foreclosure_real_esate_lawyer": "Execução hipotecária",
      "landlord_tenant_law": "Direito do proprietário e do inquilino",
      "litigation_real_estate_lawyer": "Litígio",
      "mortgage_lending_law": "Direito hipotecário e de empréstimos",
      "neighbor_hoa_disputes": "Disputas entre vizinhos e associação de moradores",
      "property_damage": "Danos materiais",
      "purchase_agreements": "Contratos de compra",
      "real_estate_contracts_transactions": "Vendas imobiliárias",
      "real_estate_lawyer_other": "Outro",
      "residential_real_estate": "Imobiliário residencial",
      "title_services": "Serviços de títulos",
      "trespassing": "Invasão",
      "rehab_other": "Outro",
      "attic_venting": "Ventilação do sótão",
      "gutter_installation": "Instalação de calha",
      "gutter_repair": "Reparo de calhas",
      "roof_inspection": "Inspeção de telhado",
      "roof_installation": "Instalação de Telhado",
      "roof_repair": "Reparo de Telhado",
      "roofer_other": "Outro",
      "skylight_installation": "Instalação de Claraboia",
      "skylight_repair": "Reparo de claraboia",
      "storm_wind_damage_roof_repair": "Reparo de Danos no Telhado",
      "sewage_cleaning": "Limpeza",
      "sewage_excavation": "Escavação",
      "sewage_inspection": "Inspeção",
      "sewage_installation": "Instalação",
      "sewage_locating": "Localizando",
      "sewage_maintenance_repairs": "Manutenção e Reparos",
      "sewage_pro_other": "Outro",
      "sewage_pumping": "Bombeamento",
      "sewage_removal_demolition": "Remoção ou Demolição",
      "remodeling_siding_pro": "Reforma",
      "repair_maintenance_siding_pro": "Reparação e manutenção",
      "siding_installation": "Instalação de revestimentos",
      "siding_pro_other": "Outro",
      "siding_removal": "Remoção de revestimento",
      "smart_home_other": "Outro",
      "commercial_snow_removal": "Remoção de neve comercial",
      "residential_plowing": "Aragem residencial",
      "residential_shoveling_blowing": "Remoção de neve residencial com pá e soprador",
      "salt_sand_deicing": "Sal, areia e degelo",
      "snow_relocation": "Realocação de neve",
      "snow_removal_other": "Outro",
      "body_polish": "Esfoliação corporal",
      "body_wrap": "Envoltório corporal",
      "facial": "Facial",
      "hydrotherapy": "Hidroterapia",
      "manicure": "Manicure",
      "massage": "Massagem",
      "pedicure": "Pedicure",
      "peels": "Peelings",
      "spa_other": "Outro",
      "spa_packages": "Pacotes de spa",
      "tanning": "Bronzeamento",
      "waxing": "Depilação com cera",
      "civil_tax_litigation": "Litígio fiscal civil",
      "corporate_taxes": "Impostos corporativos",
      "criminal_tax_litigation": "Litígio fiscal criminal",
      "estate_tax_planning": "Planejamento de imposto sobre patrimônio",
      "failure_to_file": "Falha em arquivar",
      "innocent_spouse_relief": "Alívio para cônjuge inocente",
      "international_tax_services": "Serviços fiscais internacionais",
      "irs_tax_problems": "Problemas fiscais com o IRS",
      "non_collectible_status": "Status não cobrável",
      "offer_in_compromise": "Oferta de compromisso",
      "tax_audits": "Auditorias fiscais",
      "tax_lawyer_other": "Outro",
      "tax_liens_levies": "Penhoras e tributos",
      "tax_planning_lawyer": "Planejamento tributário",
      "tax_relief": "Alívio fiscal",
      "accounting_support": "Suporte contábil",
      "business_incorporation_restructuring": "Incorporação e reestruturação",
      "cryptocurrency_taxes": "Impostos sobre criptomoedas",
      "irs_audit_representation": "Representação em Auditoria do IRS",
      "irs_filing": "Declaração de Imposto de Renda",
      "irs_problem_consulting": "Consultoria para problemas com o IRS",
      "new_business_services": "Novos serviços da empresa",
      "payroll_support": "Suporte de Folha de Pagamento",
      "tax_planning_tax_specialist": "Planejamento tributário",
      "tax_preparation": "Preparação de imposto",
      "tax_problem_consulting_tax_specialist": "Consultoria em questões tributárias",
      "tax_specialist_other": "Outro",
      "therapist_other": "Outro",
      "battery_service": "Serviço de Bateria",
      "car_towing": "Reboque de Carro",
      "fuel_delivery": "Entrega de Combustível",
      "local_hauling": "Transporte local",
      "long_distance_hauling": "Transporte de longa distância",
      "motorcycle_towing": "Reboque de motocicleta",
      "special_vehicle_towing": "Reboque de veículos especiais",
      "tire_change": "Troca de pneu",
      "towing_other": "Outro",
      "case_assessment_traffic_lawyer": "Avaliação de Caso",
      "cdl_traffic_ticket": "Multa de trânsito com carteira profissional (C, D ou E)",
      "dui_dwi_traffic_lawyer": "Condução sob influência de substâncias psicoativas",
      "fixit_ticket": "Multa de reparação",
      "parking_ticket": "Multa de estacionamento",
      "reckless_driving_traffic_lawyer": "Direção Imprudente",
      "red_light_ticket": "Multa por sinal vermelho",
      "speeding_ticket": "Multa por excesso de velocidade",
      "suspended_license": "Licença suspensa",
      "traffic_lawyer_other": "Outro",
      "traffic_ticket": "Multa de trânsito",
      "cabling_and_bracing": "Cabeamento e reforço",
      "stump_removal": "Remoção de Tocos",
      "tree_planting": "Plantio de Árvores",
      "tree_removal": "Remoção de Árvores",
      "tree_service_other": "Outro",
      "tree_transplanting": "Transplante de Árvores",
      "tree_trimming_and_pruning": "Corte e poda de árvores",
      "tutor_computer_science": "Ciência da Computação",
      "tutor_foreign_languages": "Idiomas estrangeiros",
      "tutor_geography": "Geografia",
      "tutor_government_and_economics": "Governo e economia",
      "tutor_history": "Histórico",
      "tutor_homework_help": "Ajuda com a lição de casa",
      "tutor_math": "Matemática",
      "tutor_other": "Outro",
      "tutor_reading_and_writing": "Leitura e escrita",
      "tutor_science": "Ciência",
      "tutor_special_education": "Educação Especial",
      "tutor_test_pre_college_entrance": "Preparação para o teste: ingresso na faculdade",
      "tutor_test_prep_grad_school_entrance": "Preparação para o teste: ingresso na pós-graduação",
      "tutor_test_prep_k8": "Preparação para o teste: K-8",
      "area_rug_cleaning": "Limpeza de tapetes",
      "drapery_and_blind_cleaning": "Limpeza de Cortinas e Persianas",
      "leather_cleaning": "Limpeza de Couro",
      "mattress_cleaning": "Limpeza de colchão",
      "upholstery_cleaner_other": "Outro",
      "upholstery_cleaning": "Limpeza de Estofados",
      "upholstery_water_damage_cleanup": "Limpeza de danos causados pela água",
      "bird_exotic_animal_care": "Cuidados com aves e animais exóticos",
      "farm_barn_animal_care": "Cuidados com animais de fazenda e celeiro",
      "microchipping": "Microchipagem",
      "veterinarian_allergies": "Alergias",
      "veterinarian_behavior_counseling": "Aconselhamento Comportamental",
      "veterinarian_dental_care": "Cuidados dentários",
      "veterinarian_dermatology": "Dermatologia",
      "veterinarian_emergency_care": "Atendimento de Emergência",
      "veterinarian_end_of_life_care": "Cuidados paliativos",
      "veterinarian_examinations": "Exames",
      "veterinarian_nutrition_counseling": "Aconselhamento nutricional",
      "veterinarian_other": "Outro",
      "veterinarian_preventive_care": "Cuidados Preventivos",
      "veterinarian_spay_neuter": "Castrar ou Esterilizar",
      "veterinarian_surgery": "Cirurgia",
      "veterinarian_vaccinations": "Vacinas",
      "aerial_videography": "Videografia Aérea",
      "documentary_video_production": "Produção de Documentários",
      "family_video_production": "Produção de vídeo familiar",
      "live_streaming": "Transmissão ao vivo",
      "photography": "Fotografia",
      "product_demonstrations": "Demonstração de Produto",
      "promotional_video_production": "Produção de vídeo promocional",
      "real_estate_video_production": "Produção de vídeo imobiliário",
      "special_event_video_production": "Produção de vídeo para eventos especiais",
      "video_editing": "Edição de Vídeo",
      "videographer_other": "Outro",
      "voice_overs": "Locução",
      "wedding_video_production": "Produção de vídeo de casamento",
      "fire_damage_cleanup_repair": "Limpeza/reparo de danos causados por incêndio",
      "water_damage_cleanup_repair": "Limpeza de danos causados pela água",
      "water_damage_flooring": "Pisos",
      "water_damage_mold_inspection": "Inspeção de mofo",
      "water_damage_mold_removal": "Remoção de Mofo",
      "water_damage_other": "Outro",
      "water_damage_painting": "Pintura",
      "water_damage_pest_control": "Controle de pragas",
      "water_damage_plumbing": "Encanamento",
      "water_damage_remodeling": "Reforma",
      "water_damage_roofing": "Cobertura",
      "water_damage_sewage_cleanup": "Limpeza de esgoto",
      "adult_weight_loss_programs": "Programas de perda de peso para adultos",
      "diet_and_nutrition_counseling": "Aconselhamento sobre dieta e nutrição",
      "kids_weight_loss_programs": "Programas de perda de peso para crianças",
      "metabolic_testing": "Teste Metabólico",
      "weight_loss_consultation_and_training": "Consultoria e treinamento",
      "weight_loss_fitness_programs": "Programas de condicionamento físico",
      "weight_loss_meal_planning": "Planejamento de Refeições",
      "weight_loss_personal_training": "Treinamento pessoal",
      "weight_loss_service_other": "Outro",
      "weight_loss_wellness_programs": "Programas de bem-estar",
      "glass_and_mirror_cleaning": "Limpeza de Vidros e Espelhos",
      "gutter_cleaning": "Limpeza de Calhas",
      "power_pressure_washing": "Lavagem a pressão/potência",
      "rooftop_skylight_cleaning": "Limpeza de telhados/claraboias",
      "window_cleaner_other": "Outro",
      "window_cleaning": "Limpeza de janelas",
      "door_installation": "Instalação de portas",
      "door_repair": "Reparo de portas",
      "glass_installation": "Instalação de Vidro",
      "window_boardup": "Tábuas",
      "window_installation": "Instalação de janelas",
      "window_repair": "Reparo de janelas",
      "window_repair_other": "Outro",
      "install_new_wiper_blades": "Instalar novas palhetas do limpador",
      "repair_power_window": "Conserto de janela elétrica",
      "repair_water_leak": "Reparar vazamento de água",
      "repair_windshield": "Conserto de para-brisa",
      "replace_rear_window": "Substituir janela traseira",
      "replace_side_view_mirrors": "Conserto de espelhos laterais",
      "replace_side_window": "Substituir janela lateral",
      "replace_sunroof": "Substituir o vidro do teto solar",
      "replace_windshield": "Substituir para-brisa",
      "windshield_other": "Outro",
      "ashtanga": "Ashtanga",
      "hatha": "Hatha",
      "hot_yoga": "Hot Yoga",
      "iyengar": "Iyengar",
      "kundalini": "Kundalini",
      "meditation": "Meditação",
      "power_yoga": "Power Yoga",
      "restorative": "Restauração",
      "vinyasa": "Vinyasa",
      "yin": "Yin",
      "yoga_instructor_other": "Outro"
    }
  }
}
